import { FlightPreparationService } from "../flight-preparation.service";
import { addRouteDocuments } from "../../briefing-flow/briefing-flow.documents";
import { routeObstacleIconHref } from "../terrain/route-obstacle-icon";
import { DatabaseService } from "../database/database.service";
import { FileSystemService } from "../file-system/file-system.service";
/* eslint-disable guard-for-in */
/* eslint-disable new-cap */
/* eslint-disable camelcase */
import { flowBriefingGaps } from "./flow-briefing-gaps";
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { NavController } from "@ionic/angular";
import { Subject, debounceTime } from "rxjs";
import { SyncChangesService } from "../../sync/sync-changes.service";
import { setChainRuns } from "../../sync/window-id";
import {
  airportHeliportSearchStruct,
  dutyAuthStruct,
  dutyOfpPerfEnvStruct,
  flightlistStruct,
  opsMissionTypeEnum,
  payloadCodeTypeEnum,
  property,
  targetPlatformEnum,
} from "../../plugins/opsctrl-foc/dataStruct";
import {
  execAccuParameters,
  getParameter,
  parseCss,
  translateToFplCoordinates,
} from "../../plugins/opsctrl-foc/functions";

import { metarReport } from "../../plugins/opsctrl-foc/class/metarReport";
import * as paramCache from "../../plugins/opsctrl-foc/param-cache";
import * as userReadCache from "../database/user-read-cache";
import { loadBriefingCard } from "../../briefing-flow/briefing-flow.loader";
import { notamReport } from "../../plugins/opsctrl-foc/class/notamReport";
import { aircraftStruct } from "../../plugins/opsctrl-foc/class/providers/fppProvider";
import {
  briefgFlowContentEnum,
  briefgFlowFlightStatusEnum,
  briefgFlowFlightStruct,
  briefingFlowFeatures,
  classCom,
  focMain,
  fuelFeatures,
  mAndBandPerformance,
  navigationalFeatures,
  performance,
} from "../../plugins/opsctrl-foc/focMain";

import { DEFAULT_CEILING_FT, Point, RouteType } from "src/app/models";
import { performanceReport } from "src/app/plugins/opsctrl-foc/class/performanceReport";
import { fccProvider, isMissingDutyId } from "src/app/plugins/opsctrl-foc/class/providers/fccProvider";
import { plugins } from "src/app/plugins/plugins";
import { fuelCalcReport } from "../../plugins/opsctrl-foc/class/fuelCalcReport";
import { navLegStruct, navLogReport, round } from "../../plugins/opsctrl-foc/class/navLogReport";
import { pmtilesElevAt } from "../terrain/terrain-pmtiles";
import { ObstacleSpan } from "../terrain/route-obstacle-profile";
import { AlertService } from "../alert/alert.service";
import { AuthService } from "../auth/auth.service";
import { ConfigService } from "../config/config.service";
import { GeolocationService } from "../geolocation/geolocation.service";
import { MissionService } from "../mission/mission.service";
import { NavService } from "../nav/nav.service";
import { PointInterface } from "../route/route.service";
import { RoutesHandlingService } from "../routes-handling/routes-handling.service";
import { SettingsService } from "../settings/settings.service";
import { StorageService } from "../storage.service";
import { UpdatesService } from "../updates/updates.service";
import { PLATFORM_ADAPTER } from "../../core/platform/platform.adapter";
import { CrashRecoveryService } from "../crash-recovery/crash-recovery.service";
import { AircraftStateService } from "../aircraft-state/aircraft-state.service";
import { AircraftFuel } from "../aircraft-state/aircraft-state";
import { ClientTokenService } from "../auth/client-token.service";
import { isTransientProcessDbError } from "../database/http-error";

// Mirrors `minPersonAboardReq_flightcrew` in `focMain.initMassAndBalance`,
// which is a function-local const and cannot be imported. Keep the two in step:
// if that gate ever moves off 1, this check lets a value through that mass and
// balance then refuses — and its refusal both latches `classCom.msgErr` and
// stops the whole ahead chain.
const MIN_PERSONS_ABOARD = 1;

// `lastError` is typed `unknown` on the calculation classes, and a bare
// string-concat renders a plain object as `[object Object]` — which tells the
// operator nothing at exactly the moment the docblock contract says to surface
// the cause.
function describeError(err: unknown): string {
  if (err === undefined || err === null) return "no further detail available";
  if (err instanceof Error) return err.message;
  if (typeof err === "string") return err;

  try {
    return JSON.stringify(err);
  } catch {
    return String(err);
  }
}

// Module scope, not class fields, so a test can assert against the SAME value the
// service uses. A `private readonly` field initializer is an OWN property created
// by the constructor, so a harness that builds the service without running the
// constructor has to supply its own copy -- and then a regression in the class
// value cannot fail that test.
export const RETRY_DELAY_MS: number = 60 * 1000;
export const BRIEFING_PERIOD_MS: number = 600 * 1000;

/** How long a started duty check or card load may answer a later asker. See `joinRun`. */
export const RUN_SHARE_MS: number = 5 * 1000;

/** A started run of a read-only job, kept so a second asker can reuse it. */
interface SharedRun<T> {
  promise: Promise<T>;
  key: string;
  startedAt: number;
  generation: number;
}

@Injectable({
  providedIn: "root",
})
export class opsControlService {
  private routeDocumentDb = inject(DatabaseService);
  private routeDocumentFs = inject(FileSystemService);
  private alert = inject(AlertService);
  private authS = inject(AuthService);
  private missionService = inject(MissionService);
  private navCtrl = inject(NavController);
  private navS = inject(NavService);
  private auth = inject(AuthService);
  private settings = inject(SettingsService);
  private routeCtrl = inject(RoutesHandlingService);
  private geoLocSer = inject(GeolocationService);
  private router = inject(Router);
  private configCtrl = inject(ConfigService);
  private storage = inject(StorageService);
  private updateSer = inject(UpdatesService);
  private crashRecovery = inject(CrashRecoveryService);
  private aircraftState = inject(AircraftStateService);
  private platformAdapter = inject(PLATFORM_ADAPTER);
  private clientToken = inject(ClientTokenService);

  /**
   * The signing PIN, from the same source the sign path uses.
   *
   * Mirrors `duty-ofp-limits-page.component.ts getSigningPin()`, with a
   * null-safe device read. Use it for EVERY duty-limits lookup in this service,
   * not just the validity probe — a split source is worse than the original bug
   * (the probe passes, then the fetch misses and returns undefined). It
   * did not mirror before: this service read `getLoginInformation_device().pin` on every
   * platform, while the web sign writes the ident from `getWebPin()`. On web
   * the device pin is the `"WEB"` fallback for an unsigned duty
   * (`web-session-bootstrap.service.ts`), so `getDutyLimitsIfAlreadySignedAnd-
   * Stillvalid` looked up `"WEB-<reg>"`, missed the row the pilot had just
   * signed, and the `!valid` branch bounced them from `/flow-briefing` straight
   * back to `/duty-ofp-limits`. Only visible since the landing route moved to
   * `/flow-briefing` (`c61d8300`) — that is what arms this navigation.
   */
  public getSigningPin(): string {
    return this.platformAdapter.isNative ? this.authS.getLoginInformation_device()?.pin : this.clientToken.getWebPin();
  }

  // loaded from efb-webcam-service
  public webcamLiveUrl: string = "";

  // event setter/getter

  public TRIGGER_navfeatures: boolean = false; // this creates all calculations: W/b, fuel, navlog, perf and wx
  private BUSY_navfeatures: boolean = false;

  /** A route recompute is requested or running. The request lives in memory only. */
  public get routeRecomputePending(): boolean {
    return this.TRIGGER_navfeatures || this.BUSY_navfeatures;
  }

  public TRIGGER_briefing: boolean = true;
  private BUSY_briefing: boolean = false;
  /** A rebuild that someone requested is running; the trigger is already cleared. */
  private briefingRequestRunning: boolean = false;
  public TIMESTAMP_briefing: number = 0;

  // Failure backoff, distinct from the arms' normal cadence: 0 while the arm is
  // free to run, a future time only after a throw. It exists so a failing arm
  // keeps its pending request instead of having to choose between dropping the
  // request and retrying at tick rate. Cleared on the next successful entry.
  private RETRY_navfeatures: number = 0;
  private RETRY_briefing: number = 0;

  // Last value pushed into isUpdating. The emitter below runs on every 1 s tick,
  // so it must not re-announce a value nobody changed -- see emitIsUpdating().
  private lastIsUpdating: boolean | undefined = undefined;

  public TIMESTAMP_liveValueCheck: number = 0;
  public BUSY_liveValueCheck: boolean = false;

  public focMain: focMain;
  public isInProgress = new Subject<boolean>();
  public progressMessage = new Subject<string>();
  public isUpdating = new Subject<boolean>();
  public registration: string;
  public acftType: string;
  public crewDesig: string;
  public pic: string;
  public signature: string;
  public limitsDesignator: string;
  public missionTypesSelected: string;
  // those values are beeing displayed on the login page
  public currentDutyCrew: string;
  public currentDutyPic: string;

  // is training duty
  public isTrainingMode: boolean = false;
  public isSimulatorMode: boolean = false;

  // duty OFP
  public currentDutyOfpLimits: dutyAuthStruct; // to be used when a flight is created,
  public typeOfDuty: dutyTypeEnum;
  public duty_has_changes: boolean; // that indicates if there is a changed duty (dutyId=0 exists)

  // to avoid requery

  // controls/pages (needs to be here due angular triggers)
  public briefingFlowContent_forPageHtml: briefgFlowComponentStruct[];
  public flightAdded_allowScrolling: boolean = false;
  public flightAdded_allowScrolling_targetFlight: string;

  // dictionary of user controlled panel toggle minimize / maximize actions
  public flightPanelState_1maximized_2minimized: { [id: string]: number } = {};
  public flightPanelState_1maximized_2minimized_userOverride: {
    [id: string]: number;
  } = {};

  // flow briefing container
  public flowBriefingData: briefgFlowFlightStruct[];

  // fuel on board variable
  public fuelOnBoard_lastSync: number = 0;
  // True when the aircraft has a synced fuel record; replaces the meaning "0 = never set" for callers.
  public hasFuelRecord: boolean = false;
  // Emits the kg after this device adopted a figure from the record.
  public fuelAdopted$ = new Subject<number>();

  // flight timer start
  public lastFlightTimerStart: number = 0;

  // we have that to determine tricky routing states, such as going back
  // to the flowbriefingpage after adding a flight-timer-record, in case
  // no follow-up flight has been created.
  public routingState: string = "";

  // route handling
  // the planned route is handled by this service,
  // as change it during flight should not affect the planned route
  // and mess it up.
  public currMapFlight_plannedRoute: PointInterface[] = [];
  public focusPlannedRouteFlightId: string | undefined;

  // max flights queried (listallflights)
  private MAX_FLIGHTS_QUERY: number = 10;

  public updateBusy: boolean = false;

  // Burn handed to `fuelAndExtraMassPobSync` that no commit has applied yet,
  // because a wait or a precondition sent the call back. Read-only outside, so
  // `flight-timer` can record a landing fuel that accounts for the arrears it
  // could not get committed.
  private unappliedFuelBurn: number = 0;

  public get unappliedFuelBurnKg(): number {
    return this.unappliedFuelBurn;
  }

  /**
   * The fuel the aircraft is believed to hold RIGHT NOW — the last committed
   * figure with any burn that has not yet been applied to it taken off.
   *
   * **Every consumer of "how much fuel is on board" reads this, never
   * `fuelOnBoard_lastSync` directly.** One deliberate exception exists:
   * `duty-ofp-limits` tests the raw field for 0 to ask whether a figure was
   * ever committed, which is a different question — this accessor can be a
   * legitimate 0.
   *
   * The two-part state is an implementation detail of this service: the raw field
   * is the last figure that was successfully committed, which is HIGH by
   * whatever the arrear holds. Five call sites used to read the raw field and
   * disagree about whether the arrear was already in it, and each one fixed in
   * isolation widened the disagreement with the rest — a divert warning
   * computed low while the filed flight plan and the briefing card read high,
   * on the same aircraft in one workflow.
   *
   * It follows that any absolute figure a caller hands back to
   * `fuelAndExtraMassPobSync` is a statement about the CURRENT fuel, so it
   * settles the arrear. That is only sound because everyone reads this
   * accessor; do not reintroduce a raw read without revisiting the settle.
   */
  public get fuelOnBoardNowKg(): number {
    return Math.max(0, this.fuelOnBoard_lastSync - this.unappliedFuelBurn);
  }

  private recycleAheadFlightsBusy: boolean = false;

  // The in-flight recycle, so a sync arriving mid-recycle can WAIT for it
  // instead of being rejected — see `fuelAndExtraMassPobSync`. Never rejects:
  // the recycle handles its own failures, and a waiter only needs to know when
  // the flag clears.
  private recycleAheadFlightsPending: Promise<void> | undefined = undefined;

  // At most ONE waiter. Not because a second would be redundant — the triggers
  // carry different payloads (an operator FOB, a POB change, a burn delta), so
  // a discarded second waiter can lose real data. The cap is the storm bound:
  // each recycle is `flights × missionTypes` calculation passes with no request
  // timeout anywhere on the path, so an unbounded queue can outrun the duty.
  // The discarded case is alerted, and logged as open in the workspace
  // `TODO.md` ("a second waiter's payload is discarded").
  private recycleAheadFlightsWaiting: boolean = false;

  constructor() {
    const pluginInstance = inject(plugins);

    this.focMain = pluginInstance.focMain;
    queueMicrotask(() => {
      this.loadSignedDutyHeaderFast().catch((err) => console.error(err));
    });

    // General trigger — recompute pipeline (navfeatures recalc, briefing
    // refresh, live-value checks). Runs on BOTH platforms.
    //
    // This used to be gated to native, on the premise that "the web SPA is a
    // read-only viewer of published data". That premise stopped being true when
    // the web create-flight write pipeline landed: the SPA now writes flights,
    // fuel and duty rows through the named-query catalog. What survived was a
    // ticker that never ran on web, so every flag it consumes was write-only
    // there — the web pages set `TRIGGER_briefing` (create-flight, map,
    // preview-ifps-flightplan) and `TRIGGER_navfeatures` (map route edit) exactly
    // as the native ones do, and nothing read them.
    //
    // That single gap is both of Oliver's 2026-08-15 reports. "I don't see the
    // created flight" and "fuel is still zero until I edit it later" are one
    // defect — the flow-briefing card only reloaded on `ionViewDidEnter`, so
    // leaving the page and coming back was the only way to see a correct write.
    // "Some update triggers don't fire" is the same gate seen from the other
    // flags: no navlog/OFP recompute after a route edit, and no `isUpdating` or
    // `progressMessage` feedback at all.
    //
    // Every arm inside `triggerHandler` is already flag- or timestamp-gated, so
    // the slower web tick costs two field reads when there is nothing to do. Web
    // ticks at 2 s rather than native's 1 s because its DB round-trip is an HTTP
    // hop, not an in-process call.
    setInterval(
      () => {
        this.triggerHandler(false).catch((err) => console.error("triggerHandler: ", err));
      },
      this.platformAdapter.isNative ? 1000 : 2000
    );

    // A new, deleted or changed flight, from any source: another device, another
    // tab, or this page (#962). Before, a flight from elsewhere showed only at
    // the ten-minute refresh. `nav` too: a flight create writes its nav log
    // seconds after the flight row, and the card leaves out a flight that has
    // none, so a rebuild on the flight row alone missed the new flight.
    // `fuel`, `loading` and `perf` feed the card's chips, and the calculation
    // chain writes them after the nav log: without them a peer's new or
    // recalculated flight kept stale chips until the ten-minute refresh. The
    // cost is one extra rebuild after this device's own recalculation: the
    // server sends a web write back, and native reports its own writes. The
    // debounce turns a burst of ops into one rebuild.
    const syncChanges = inject(SyncChangesService);
    // The chain raises the briefing trigger itself when it ends. The echo of
    // its last writes arrives after that, so it is left out here: it started
    // a second rebuild after each recalculation.
    setChainRuns(() => this.chainRuns());
    syncChanges
      .changesNotOwnChain("flightlist", "nav", "fuel", "loading", "perf")
      .pipe(debounceTime(1000))
      .subscribe(() => this.onFlightChange());

    // A route edited on another device or tab: reload the flight on the map.
    // The flight timer also writes `nav` at every waypoint passed, so this
    // runs in flight too (`onRouteChange` says when it must not).
    syncChanges
      .changes("nav", "navseg")
      .pipe(debounceTime(1000))
      .subscribe(() => void this.onRouteChange());

    // A peer changed the aircraft's fuel record: take its figure.
    this.aircraftState.fuelAdopted$.subscribe((fuel) => void this.adoptAircraftFuel(fuel));

    this.updateSer.updatesBeingInstalled.subscribe({
      next: (v) => {
        // An installed update is the one event that can turn an ad-hoc crew
        // into a managed one — a new roster lands in the CIS duties table —
        // and `updateBusy` was written here and read nowhere, so this service
        // learned nothing from it. Run the duty re-check on the install->idle
        // edge instead.
        //
        // Call it DIRECTLY rather than raising `TRIGGER_briefing`. The flag is
        // the briefing arm's, and the arm also runs `loadFlowBrfg` — a full
        // briefing rebuild the install did not invalidate — plus it drives
        // `isUpdating`, which every `met-aware` component subscribes to with an
        // uncached radar `fetch`. The duty re-check is the only thing an
        // install actually invalidates, so raise only that.
        //
        // TWO THINGS THIS IS *NOT*. It is not the only wake-up: while the
        // operator is on flow-briefing, that page subscribes
        // `updatesInstalledFinished` and its `refresh()` already raises this
        // same flag within a second. This arm covers the case where the
        // operator is somewhere else. And it does NOT cover a page holding
        // `haltTrigger` (map, file-system, edit-add-flightplan) — the handler
        // returns before this arm while that is set, so the re-check waits for
        // the page to release it, whichever field was raised.
        //
        // Caught: `checkDutyLimitsValid` is `try`/`finally` with no `catch`,
        // and nothing downstream of a subject callback would handle a rejection.
        if (this.updateBusy && !v) {
          this.checkDutyLimitsValid().catch((err) => console.error("checkDutyLimitsValid: ", err));
        }
        this.updateBusy = v;
      },
    });

    this.missionService.alert.subscribe((evt) => {
      this.handleMissionAlert(evt)
        .then((opened) => {
          // An opened form reports its own end (edit-add-flightplan).
          if (!opened) this.missionService.autoAcceptDone(evt.id);
        })
        .catch((error) => {
          this.missionService.autoAcceptDone(evt.id);
          console.error("Mission alert: ", error);
          this.alert.showAlert("Mission", "The mission could not be opened. Please try again.");
        });
    });
  }

  /**
   * A flight, its nav log or a calculation result changed. The route recompute
   * and the ahead-flight recycle on this device write these tables too. The
   * recompute raises the trigger when it succeeds; the recycle raises it when
   * it ends, failed or not, because no retry follows it. While one of them runs,
   * or a failed route recompute waits for its retry, a rebuild would show a
   * half-recomputed card. Their own writes arrive here after the debounce, so
   * a busy flag alone is not enough: `TRIGGER_navfeatures` stays set until the
   * recompute succeeds.
   */
  private onFlightChange(): void {
    if (this.chainRuns()) return;
    this.TRIGGER_briefing = true;
  }

  /** The route recompute or the ahead-flight recycle runs, or a recompute waits for its retry. */
  private chainRuns(): boolean {
    return this.TRIGGER_navfeatures || this.BUSY_navfeatures || this.recycleAheadFlightsBusy;
  }

  /**
   * The table event names no flight, so any route change reloads the flight on
   * the map. Skipped while this device edits or recomputes a route, or creates
   * a flight: those show their own result, and a reload would replace the
   * route being edited. Skipped too when the route on the map differs from
   * what the last load drew (`loadedRouteKey`): the map page keeps route edits
   * in memory until it is left, so a reload would drop them. The delayed draw
   * checks again (`mayDrawRoute`): an edit made or saved while the reload
   * read stops it, and so does a draw by a load that read later. `alterRoute`
   * updates the key when the map is left with that route still shown. A
   * skipped change waits for the next route change; in flight that is the next
   * waypoint passed.
   */
  private async onRouteChange(): Promise<void> {
    if (!this.currentEditFlightId || this.MapInEditMode) return;
    if (this.shownRouteKey() !== this.loadedRouteKey) return;
    if (this.TRIGGER_navfeatures || this.BUSY_navfeatures || this.flightCreateRunning) return;
    try {
      await this.setCurrentFlightInMapView(this.currentEditFlightId, true, true);
    } catch (err) {
      console.error("onRouteChange: ", err);
    }
  }

  /** Counts route loads, taken just before each load reads the stored route. */
  private routeLoadSeq = 0;
  /** Per flight, the load that drew it last. */
  private routeDrawn = new Map<string, number>();
  /** The newest load the crew asked for. An older crew load of another flight takes nothing. */
  private routeCrewLoad = { seq: 0, flightId: "" };
  /** Counts route writes for the shown flight (`routeSaved`). */
  private routeSaves = 0;

  /**
   * Whether a load may draw what it read. `seq` and `saves` are the counters
   * as they were just before its read.
   * - The edit page clears the id when it takes the map, and a later load sets
   *   another one: either way this flight is no longer the one shown.
   * - A load of this flight that read later has drawn already: this one holds
   *   older data.
   * - A sync reload (`keepEdits`) also stops when the crew saved a route since
   *   the read (the read is older than the save), or edited the shown route.
   */
  private mayDrawRoute(flightId: string, seq: number, saves: number, keepEdits?: boolean): boolean {
    if (this.currentEditFlightId !== flightId) return false;
    if (this.routeReadIsOld(flightId, seq)) return false;
    if (!keepEdits) return true;
    return saves === this.routeSaves && this.shownRouteKey() === this.loadedRouteKey;
  }
  /** A load of this flight that read later has drawn already. */
  private routeReadIsOld(flightId: string, seq: number): boolean {
    return seq < (this.routeDrawn.get(flightId) ?? 0);
  }
  /**
   * `alterRoute` ended for the shown flight. A write (`wrote`) makes every
   * reload that read before it stale. The shown route is the stored one now,
   * so a route change elsewhere may reload it again (`onRouteChange`). Not
   * when another load drew the map meanwhile: the key then belongs to that
   * draw.
   *
   * Without a write the key moves too. `alterRoute` does not store a waypoint
   * moved by less than 0.1 degree, so such a move is not an edit, and a reload
   * may replace it with the stored route. Do not keep the key back to protect
   * it: every later reload is then skipped, and the next map leave writes this
   * device's route over a peer's change (decided 2026-10-03).
   */
  private routeSaved(flightId: string, savedKey: string, wrote: boolean): void {
    if (this.currentEditFlightId !== flightId) return;
    if (wrote) this.routeSaves += 1;
    if (this.shownRouteKey() === savedKey) this.loadedRouteKey = savedKey;
  }
  /** The route on the map as the last `setRouteInMapview` drew it. */
  private loadedRouteKey = "";
  /**
   * The flight a crew load gave the map to, until its delayed draw. In that
   * second the map still shows the flight before it, so `alterRoute` must not
   * save the shown points into this flight.
   */
  private routeDrawPending = "";

  /** Names and positions only: drawing rewrites display names (`cleanRoute`). */
  private shownRouteKey(): string {
    return JSON.stringify(this.routeCtrl.activeRoute.getAllPoints().map((p) => [p.name, p.point]));
  }

  /** True when it opened the create form for the mission. */
  private async handleMissionAlert(evt: { destination: string; body: string; id: number }): Promise<boolean> {
    // log
    this.settings.logPush("mission-trigger received");

    // check if we are logged in
    if (this.platformAdapter.isNative ? this.authS.authLogin_user : !!this.clientToken.getTokenSync()) {
      // log
      this.settings.logPush("missionService -> user is logged in!");

      // The mission template reads the PIC's phone number from the crew rows.
      // A duty dropped on another device stays signed here but has none.
      const valid: boolean = await this.missionDutyReady();

      if (valid) {
        // log
        this.settings.logPush("missionService -> duty limits are valid, " + (classCom?.activeDutyDesig ?? ""));

        // set last alert id set
        const coords: string[] = evt.destination.split(",");

        // Someone opened another screen while the duty was checked. Defer
        // before the parameters are set: add-menu reads them on its next open.
        if (evt.id === this.missionService.autoPendingId && !this.missionService.autoAcceptIdle()) {
          this.missionService.autoAcceptDefer(evt.id);
          return false;
        }
        this.navS.setParameters({
          missionCoords: [round(parseFloat(coords[0]), 10), round(parseFloat(coords[1]), 10)],
          opsRemarks: evt.body,
          opsMissionId: evt.id,
        });
        // Ionic reuses a page already in the stack and does not construct it
        // again, so a stale add-menu would ignore this mission. Nobody clears
        // the stack in the unattended auto-accept window, so start it fresh.
        if (evt.id === this.missionService.autoPendingId) await this.navCtrl.navigateRoot("/flow-briefing");
        this.navCtrl.navigateForward("/add-menu").catch((err) => console.error("navigateForward: ", err));

        this.settings.logPush("alert-object:");
        this.settings.logPush(
          JSON.stringify({
            missionCoords: [round(parseFloat(coords[0]), 10), round(parseFloat(coords[1]), 10)],
            opsRemarks: evt.body,
            opsMissionId: evt.id,
          })
        );

        // set the ops-mission lastAlertId, to avoid duplicated firings
        this.missionService.lastAlertIdDisplayed = evt.id;

        this.settings.logPush("lastalertId: " + evt.id);
        this.settings.logPush(">");
        return true;
      } else {
        await this.alert.showAlert("Mission", "Sign valid duty limits before starting a mission.");
      }
    } else {
      await this.alert.showAlert("Mission", "Please log in before starting a mission.");
    }
    return false;
  }

  /** The check a mission makes before it opens the create form: a signed duty that
   *  is still valid, with a PIC. The wallboard warning asks the same question. */
  public async missionDutyReady(): Promise<boolean> {
    return (
      (await this.focMain.getDutyLimitsIfAlreadySignedAndStillvalid(this.getSigningPin())) && (await this.dutyHasPic())
    );
  }

  private async dutyHasPic(): Promise<boolean> {
    // A duty row dropped on this device leaves no duty id, and the crew read throws on that.
    if (isMissingDutyId(classCom?.activeDutyId)) return false;
    const pic = await new fccProvider().getEntireLoading(
      classCom.activeDutyId,
      false,
      classCom,
      payloadCodeTypeEnum.pic
    );
    return pic.length > 0;
  }

  private dutyHeaderBusy = false;

  async loadSignedDutyHeaderFast(): Promise<void> {
    if (this.dutyHeaderBusy) return;
    this.dutyHeaderBusy = true;

    try {
      const authInf = await this.auth.getLoginInformation_device();
      if (!authInf?.registration || authInf.registration.length < 4) return;
      if (!classCom.aircraftRegistration || classCom.aircraftRegistration === "OENWY") return;

      const flightCrew = await this.focMain.getCurrentFlightCrew(Date.now(), classCom.aircraftRegistration);
      if (!flightCrew?.length) return;

      const latest = flightCrew[flightCrew.length - 1];
      this.currentDutyPic = latest.pilotsAboard;
      this.currentDutyCrew = latest.dutyDesig;

      // Same pin source as everything else — see `getSigningPin`. This ran on
      // the device pin, which on web is the "WEB" fallback, and it is reached
      // from the web bootstrap. Worse than being merely wrong on its own:
      // `getDutyLimitsIfAlreadySignedAndStillvalid` latches on the aircraft
      // registration and NOT on the pin, so warming the latch here under one
      // pin made `checkDutyLimitsValid` report valid for a different one.
      const valid = await this.focMain.getDutyLimitsIfAlreadySignedAndStillvalid(this.getSigningPin());
      if (!valid) return;

      const dl = await this.focMain.getDutyLimits(this.getSigningPin());
      if (!dl) return;

      this.pic = dl.pilotInCommand;
      this.crewDesig = dl.crewDesignator;
      this.signature = dl.signature;
      this.currentDutyOfpLimits = dl;
    } catch (err) {
      console.error("loadSignedDutyHeaderFast", err);
    } finally {
      this.dutyHeaderBusy = false;
    }
  }

  private lastFlightCleanup = 0;
  private flightCleanupRunning = false;

  private readonly FLIGHT_CLEANUP_INTERVAL_MS = 6 * 60 * 60 * 1000; // 6 hours

  async cleanOldFlights(): Promise<void> {
    // Native-only, and that is now the complete story rather than a gap.
    //
    // Two reasons, and the second is the load-bearing one. The maintenance
    // writes (paramsDeleteInTimestampRange + flightcrewDeleteInCreatedRange +
    // removeFlight's per-table deletes) are mobile catalog entries the web SPA
    // has no permission for — but more fundamentally the web SPA keeps NO local
    // store: `database.service.browser.ts` POSTs every read and write to the
    // app-server, so there is nothing here to prune.
    //
    // Web retention is the app-server's own sweep, `src/db/retention.ts`, which
    // runs the same 3-day window against the same tables. Both sides age out on
    // the same rule; neither drives the other (the purge carries no `sync`
    // clause, and broadcasting tombstones from the server would mass-delete on
    // every connected peer).
    if (!this.platformAdapter.isNative) return;

    if (this.flightCleanupRunning) {
      return;
    }

    const now = Date.now();

    if (this.lastFlightCleanup > 0 && now - this.lastFlightCleanup < this.FLIGHT_CLEANUP_INTERVAL_MS) {
      return;
    }

    this.flightCleanupRunning = true;

    try {
      // A failed read must not stop the cleanup and must not delete more.
      let activeFlightId = "";
      try {
        const last = await this.crashRecovery.getLastFlightLoaded();
        if (typeof last?.flightId === "string") activeFlightId = last.flightId;
      } catch {
        activeFlightId = "";
      }
      let timerRunning = true;
      try {
        const started = await this.crashRecovery.getFlightTimerStartedAt();
        timerRunning = Number(started?.time) > 0;
      } catch {
        timerRunning = true;
      }
      await this.focMain.clearOldFlights({ activeFlightId, timerRunning });

      // Only mark as completed if cleanup really succeeded.
      this.lastFlightCleanup = Date.now();
    } catch (err) {
      console.error("cleanOldFlights:", err);
    } finally {
      this.flightCleanupRunning = false;
    }
  }

  // test
  async getNextFlight(): Promise<flightlistStruct> {
    let allFlights = await this.focMain.listAllFlights(new Date(), classCom.activePic, this.MAX_FLIGHTS_QUERY);
    let minTime: number = 0;
    let idx: number = -1;

    let idx_far: number = -1;

    // this identifies a flight under many (using normal filters)
    for (let i = 0; i < allFlights.length; i++) {
      const flight: flightlistStruct = allFlights[i];
      try {
        if (flight.actBlocksOnTime == undefined) {
          // check not yet departed (or arrived)

          // check ebot within 30 min
          const eobt: number = flight.estTimeDep.getTime();

          const now = new Date().getTime();

          const dif = eobt - now;
          const Seconds_from_T1_to_T2 = dif / 1000;
          const Seconds_Between_Dates = Math.abs(Seconds_from_T1_to_T2);

          const timeMargin: number = 60 * 30;

          if (Seconds_Between_Dates < timeMargin) {
            if (dif < minTime || minTime == 0) {
              minTime = dif;
              idx = i;
            }
          }

          if (dif >= minTime) {
            idx_far = i;
          }
        }
      } catch (err) {
        console.log("could read that flight: " + JSON.stringify(flight));
      }
      if (idx == -1) {
        if (idx_far !== -1) {
          return allFlights[idx_far];
        }
      }
    }

    return allFlights[idx];
  }

  async getFuelOnBoardFromStorage() {
    try {
      const fuel = await this.crashRecovery.getFuelOnBoard();
      this.fuelOnBoard_lastSync = fuel ?? this.fuelOnBoard_lastSync;
    } catch (err) {}
    await this.loadAircraftFuel();
  }

  public async adoptAircraftFuel(fuel: AircraftFuel): Promise<void> {
    this.fuelOnBoard_lastSync = fuel.kg;
    // A figure from the record is a statement about the current fuel.
    this.unappliedFuelBurn = fuel.arrear ?? 0;
    this.hasFuelRecord = true;
    try {
      await this.crashRecovery.setFuelOnBoard(fuel.kg);
    } catch (err) {
      console.error("could not persist adopted fuel on board: ", err);
    }
    this.fuelAdopted$.next(fuel.kg);
  }

  public async loadAircraftFuel(): Promise<void> {
    try {
      // Compare with the record this device last saw, not with its own figures: a burn
      // that is booked and not yet written must survive a page enter.
      const before = this.aircraftState.knownFuel;
      const fuel = await this.aircraftState.loadFuel();
      if (!fuel) return;
      if (!this.hasFuelRecord || !before || fuel.kg !== before.kg || (fuel.arrear ?? 0) !== (before.arrear ?? 0)) {
        await this.adoptAircraftFuel(fuel);
      }
      this.hasFuelRecord = true;
    } catch (err) {
      console.warn("could not load fuel on board from the aircraft record: ", err);
    }
  }

  public haltTrigger: boolean = false;
  // True while the create page runs a flight create (its Create press). The
  // auto-NAVIG window must not take over then: see AutoNavigService.
  public flightCreateRunning = false;

  private initTrigger: boolean = false;

  // The retry gate below throttles an arm's WORK. Nothing throttled the
  // ANNOUNCEMENT, and that is where the 1 Hz storm came back: the emitter runs on
  // every tick and reads TRIGGER_briefing directly, which is harmless only while
  // the arm clears its trigger on every path. Holding the trigger across a
  // failure -- the whole point of the retry gate -- otherwise announces `true`
  // once a second for the life of the session.
  //
  // Not cosmetic. met-aware.component subscribes and calls loadRadar() on every
  // `true`, which is a cache-busted fetch, and never tears the subscription down;
  // flow-briefing-auto calls processLiveValues() and shows a loading skeleton.
  private emitIsUpdating(value: boolean): void {
    if (value === this.lastIsUpdating) return;

    this.lastIsUpdating = value;
    this.isUpdating.next(value);
  }

  private preparation = inject(FlightPreparationService);

  async triggerHandler(overrideHaltTrigger: boolean) {
    if (this.preparation.busy) return;
    if (this.haltTrigger == true && overrideHaltTrigger == false) {
      this.isInProgress.next(false);
      return;
    }

    if (this.authS.getLoginInformation_device() != undefined)
      if (this.authS.getLoginInformation_device().registration.length < 4) return;

    if (this.initTrigger == false) {
      await this.checkDutyLimitsValid();
      this.initTrigger = true;
    }

    // trigger a new navlog version
    if (this.TRIGGER_navfeatures && !this.BUSY_navfeatures && this.RETRY_navfeatures < new Date().getTime()) {
      this.BUSY_navfeatures = true;

      // Clearing BOTH flags in the finally is wrong, and so is clearing the
      // trigger ahead of the awaits: alterRoute() is the ONLY writer that sets
      // TRIGGER_navfeatures, and it sets it after already committing the new
      // route -- so dropping the trigger on a throw strands navlog, fuel,
      // mass-and-balance and performance against a route that did change, with
      // nothing to re-issue the recompute short of the crew editing the route a
      // second time.
      //
      // So: clear the trigger on SUCCESS only, and give the failure path a
      // backoff of its own. The pending request survives and the retry is bounded
      // to one attempt per RETRY_DELAY_MS instead of one per tick.
      try {
        // One read cache for navlog, documents and every mission type.
        await paramCache.withParamCache(async () => {
          const navF = new navigationalFeatures();

          // navlog calc
          this.progressMessage.next("revise navlog due route change..");

          await navF.updateNav(this.currentEditFlightId, classCom);

          // loop all ops mission types given
          this.progressMessage.next("revise OFP docs due route change..");

          await this.focMain.updateBriefingDocuments(this.currentEditFlightId);

          const perfEnvVals = await this.getDutyOfpPerfEnvVars(this.currentEditFlightId);

          // The condition hash covers aircraft, crew loading and route. The
          // chain changes none of them, so the missions share one read.
          let conditionHash: Promise<string> | undefined;
          for (const opsMtype in opsMissionTypeEnum) {
            const str: number = parseInt(opsMtype);
            const en = opsMissionTypeEnum[str];
            // add a general fuelcal
            if (this.currentDutyOfpLimits.parameters.includes(en)) {
              conditionHash ??= this.focMain.getConditionHashOfFlight(this.currentEditFlightId);
              // Mission types are independent, so one failure must NOT abort the
              // rest of the loop — but it must not vanish either. The chain now
              // stops internally after a failed step, and returns false; log it so
              // a rolled-back mission type is traceable rather than silent.
              const ok = await this.focMain.updateOfpCalculations(
                this.currentEditFlightId,
                str,
                this.currentDutyOfpLimits.missionLimits.extraWeight,
                perfEnvVals.origin_elev,
                perfEnvVals.dest_elev,
                perfEnvVals.origin_oat,
                perfEnvVals.dest_oat,
                perfEnvVals.origin_qnh,
                perfEnvVals.dest_qnh,
                await conditionHash
              );
              if (!ok) {
                console.log("updateOfpCalculations failed for mission type " + en + " on " + this.currentEditFlightId);
              }
            }
          }
        });

        // Success: the request is satisfied, so retire it. progressMessage and
        // BUSY_navfeatures are cleared in the finally below.
        this.TRIGGER_navfeatures = false;
        this.RETRY_navfeatures = 0;

        this.TRIGGER_briefing = true;
        return;
      } catch (err) {
        // Nothing here used to be guarded: a throw from `updateNav` or
        // `updateBriefingDocuments` escaped with `BUSY_navfeatures` still true,
        // which permanently disabled the route-recompute arm for the life of
        // the service while the rest of the handler kept ticking. That is the
        // "some update triggers stop working" report — it needs one failure,
        // then never recovers.
        console.error("triggerHandler: navfeatures recompute failed", err);

        // Keep TRIGGER_navfeatures set -- the route change is still unprocessed
        // -- and hold this arm off for one delay. Return WITHOUT arming
        // TRIGGER_briefing: the calculations below the throw are half-applied,
        // and the briefing arm renders exactly those values as if they were
        // current. A stale card is better than a half-recomputed one, and the
        // retry arms the briefing arm itself once it succeeds.
        this.RETRY_navfeatures = new Date().getTime() + RETRY_DELAY_MS;
        return;
      } finally {
        this.progressMessage.next("");
        this.BUSY_navfeatures = false;
      }
    }

    // is progress flag

    this.emitIsUpdating(this.TRIGGER_briefing || this.briefingRequestRunning);

    // briefing flow trigger // this is triggered always after duty check --> checkDutyLimitsValid()

    // only if a duty is there
    if (
      (this.TRIGGER_briefing || this.TIMESTAMP_briefing < new Date().getTime()) &&
      !this.BUSY_briefing &&
      this.RETRY_briefing < new Date().getTime()
    ) {
      this.checkDutyLimitsValid().catch((err) => console.error("checkDutyLimitsValid: ", err));

      this.BUSY_briefing = true;

      // Two things have to be true at once, and the obvious remedies each give
      // up one of them. Releasing BUSY_briefing alone retries loadFlowBrfg at
      // tick rate. Clearing TRIGGER_briefing and pushing TIMESTAMP_briefing out
      // by ten minutes -- which is what this arm used to do, ahead of the await
      // -- throws away a refresh somebody explicitly asked for: seven call sites
      // across five pages set that trigger, and the updatesBeingInstalled
      // subscriber in the constructor zeroes the window when an install
      // finishes.
      //
      // So neither flag carries the backoff any more: RETRY_briefing does, and
      // it is the only thing here that stops the re-entry. The ten-minute window
      // is touched on success only. That also removes the
      // need for the separate `BUSY_briefing_explicit` flag this arm used to
      // carry.
      //
      // The trigger is cleared BEFORE the await, and put back on failure. A
      // request that lands during the rebuild (a peer's sync change, #962) sets
      // it again and is served on the next tick. Cleared after the await, it
      // was lost until the ten-minute window. `briefingRequestRunning` keeps
      // isUpdating true while a requested rebuild runs.
      const requested = this.TRIGGER_briefing;
      this.TRIGGER_briefing = false;
      this.briefingRequestRunning = requested;
      try {
        this.progressMessage.next("refresh flow-briefing..");

        await this.loadFlowBrfg(false);

        // Success: take the normal ten-minute window until the next periodic
        // refresh.
        this.RETRY_briefing = 0;
        this.TIMESTAMP_briefing = new Date().getTime() + BRIEFING_PERIOD_MS;
      } catch (err) {
        // `BUSY_briefing` used to be cleared inside the try, so a single throw
        // here latched it at true for the life of the service and the briefing
        // never refreshed again — the "some update triggers stop working"
        // report. It is a `finally` now, and the reason is logged: the old
        // handler discarded it.
        console.error("triggerHandler: flow-briefing refresh failed", err);

        if (requested) this.TRIGGER_briefing = true;
        this.RETRY_briefing = new Date().getTime() + RETRY_DELAY_MS;
      } finally {
        this.progressMessage.next("");
        this.BUSY_briefing = false;
        this.briefingRequestRunning = false;
      }
    }

    // ops-control live values

    if (
      (this.TIMESTAMP_liveValueCheck < new Date().getTime() || this.TIMESTAMP_liveValueCheck == 0) &&
      !this.BUSY_liveValueCheck
    ) {
      this.BUSY_liveValueCheck = true;

      // The `try` starts HERE, above the aircraft lookup, deliberately: that
      // await used to sit between the flag being set and the guarded block, so a
      // throw from getAircraftData leaked BUSY_liveValueCheck and this arm never
      // ran again -- defence in depth rather than a live defect, since
      // fppProvider.getAircraftData swallows its own errors and returns null.
      //
      // TIMESTAMP_liveValueCheck stays in the finally, and that is deliberately
      // NOT what the two arms above do -- do not "align" them. Those two carry a
      // trigger, so their timestamp had to move to the success path to stop a
      // failure discarding a pending request, and a separate RETRY_* gate took
      // over the backoff. This arm carries no trigger: a failure loses no
      // request, so its timestamp is free to serve as the backoff itself, and
      // the 30 s window IS its bounded retry.
      try {
        // check that aircraft is set:
        if (this.currMapServiceAircraft == undefined) {
          this.currMapServiceAircraft = await this.focMain.getAircraftData(classCom.aircraftRegistration);
        }

        // this will handle the live values of ops-control
        // at first, detect whether efb is activley flying, do this
        // by evaluating whether time running, and since when.
      } catch (err) {
        console.error("triggerHandler: live-value check failed", err);
      } finally {
        this.BUSY_liveValueCheck = false;
        this.TIMESTAMP_liveValueCheck = new Date().getTime() + 30 * 1000;
        this.emitIsUpdating(false);
      }
    }
  }

  // calc fallback (duty ofp) perf environment vars
  public async getDutyOfpPerfEnvVars(flightId: string): Promise<dutyOfpPerfEnvStruct> {
    try {
      let ret: dutyOfpPerfEnvStruct = new dutyOfpPerfEnvStruct();

      let nav = new navLogReport(classCom);
      const [navLegs, dutyLimits]: [navLegStruct[], dutyAuthStruct] = await Promise.all([
        nav.getLegs(this.currMapServiceAircraft, flightId),
        this.focMain.getDutyLimits(this.getSigningPin()),
      ]);
      ret.dest_qnh = dutyLimits.missionLimits.qnh;
      ret.origin_qnh = dutyLimits.missionLimits.qnh;
      const oat_at_5000: number = dutyLimits.missionLimits.oat;
      ret.origin_elev = navLegs[0].elevation;
      ret.dest_elev = navLegs[navLegs.length - 2].elevation; // -2 due alternate ist the last entry

      const gradientPer1000m: number = 6;
      const diff_2_5000ft_origin_oat: number = ((ret.origin_elev - 1500) / 1000) * gradientPer1000m;

      const diff_2_5000ft_dest_oat: number = ((ret.dest_elev - 1500) / 1000) * gradientPer1000m;

      ret.origin_oat = oat_at_5000 - diff_2_5000ft_origin_oat;
      ret.dest_oat = oat_at_5000 - diff_2_5000ft_dest_oat;

      console.log("info: " + "getDutyOfpPerfEnvVars " + JSON.stringify(ret));
      return ret;
    } catch (err) {
      console.log("err: " + "getDutyOfpPerfEnvVars " + err);
    }
  }

  // undo all changes (last minute changes of active crew)

  public async discardAllLastMinuteChanges() {
    const fcc = new fccProvider();
    await fcc.dropAdhocDuty(classCom);
  }

  // route manipulation (used if mapview or any other setter changes the route)
  public MapInEditMode: boolean = false;
  public currentEditFlightId: string = "";
  public currMapServiceFlightNumber: string = "";
  public currMapServiceAircraft: aircraftStruct | null = null;

  public virginFlightLegs: navLegStruct[] = [];
  public addFlightPage_routeFPL: string = "";
  public virginFlight_origin_geoPos: number[];
  public virginFlight_dest_geoPos: number[];
  public addFlightPage_hasUpdated: boolean = false;

  /**
   * Returns the fuel figure actually committed, or `undefined` if nothing was.
   *
   * `fuelBurnDeduction` is for callers whose figure is a DELTA off the current
   * sync rather than a number the crew typed. Pass the burn and `-1` for
   * `absFuelLoad`; the subtraction is then applied AFTER the wait below, off
   * whatever `fuelOnBoard_lastSync` holds at that point. Computing it caller-
   * side is wrong once the sync can wait: the caller's base is read before the
   * wait, so another trigger committing meanwhile made the waiter overwrite a
   * newer figure with one derived from a superseded base — and the result was
   * HIGHER than either, which is the direction of fuel error that matters.
   */
  async fuelAndExtraMassPobSync(
    absFuelLoad: number,
    extraMassLoad: number = -1,
    pobNbr: number = -1,
    fuelBurnDeduction: number = 0
  ): Promise<number | undefined> {
    try {
      // Owed BEFORE the wait, so a leg whose sync never gets past the queue cap
      // is still on the books. Every bail below leaves it owed, and only a
      // commit that APPLIES it reduces it — a caller-supplied figure applies
      // nothing and settles nothing. The arrear lives here rather than in the
      // caller because the decision that voids it — has a newer figure
      // superseded the base? — can only be made where the deduction is applied,
      // which is after the wait. A caller-side check could be overtaken by a
      // commit landing during that wait, and the arrear would then come off a
      // figure that already accounted for it, planning the ahead flights LOW.
      //
      // `Number.isFinite` and not `Math.max`, which passes `NaN` straight
      // through — and a `NaN` here is unrecoverable for the session, since
      // `NaN + x` stays `NaN` and every derived figure built from it fails the
      // guard below. The only caller filters it today; the service does not
      // rely on that.
      if (Number.isFinite(fuelBurnDeduction) && fuelBurnDeduction > 0) {
        this.unappliedFuelBurn = this.unappliedFuelBurn + fuelBurnDeduction;
      }

      // A sync arriving mid-recycle WAITS; it is not rejected. Rejecting is
      // wrong wherever the figure is a BURN DELTA rather than a number the crew
      // typed, because discarding the call never deducts that leg's burn: the
      // next one subtracts only its own leg from the same unreduced base, and
      // the fuel figure drifts HIGH, leg after leg, with nothing marking it —
      // the one direction of fuel error an EFB must not have.
      //
      // Be precise about which surfaces those are; an earlier version of this
      // comment was not. `flight-timer`'s sync is in the MID-AIR record branch
      // (`aircraftAirborne`), reached from the operator pressing the timer
      // button on the map — the landing branch carries no fuel sync at all.
      // `add-edit-flightrecord` is the one that syncs after a landing, and it
      // does so ONLY on record creation (`modeEdit == false`), so for that
      // surface "try again" is genuinely not an instruction the crew can
      // follow. Both are operator-initiated, so an alert does reach someone —
      // what neither offers is a way to re-issue the same figure. Whether
      // `add-edit-flightrecord`'s two arguments are burn-derived or crew-typed
      // is disputed between reviews and is open in `TODO.md`; only the
      // `flight-timer` caller is converted to the deduction parameter here.
      //
      // Waiting keeps the design rule intact — a precondition that fails still
      // changes nothing — because every check below runs AFTER the wait, on
      // state re-read at that point. Note the whole resolution (aircraft data,
      // the `-1` substitutions) is deliberately below this, so a waiter does
      // not act on values it read before the recycle it waited for finished.
      if (this.recycleAheadFlightsBusy) {
        if (this.recycleAheadFlightsWaiting) {
          await this.alert.showAlert(
            "recalculation already queued",
            "the ahead-flight calculations are being rebuilt and another update is already waiting behind them. Nothing was changed — try again once they finish."
          );

          return;
        }

        this.recycleAheadFlightsWaiting = true;

        try {
          // Never rejects (the recycle owns its failures), but catch anyway so
          // a waiter cannot be taken down by the run it merely waited for.
          await this.recycleAheadFlightsPending?.catch(() => undefined);
        } finally {
          this.recycleAheadFlightsWaiting = false;
        }

        // A trigger can claim the flag while this one is suspended on the wait
        // above (there is no interleaving point between the `finally` and this
        // check — no await separates them). Bail rather than wait again: one
        // wait is the cap.
        if (this.recycleAheadFlightsBusy) {
          await this.alert.showAlert(
            "recalculation already running",
            "the ahead-flight calculations were restarted before this update could be applied. Nothing was changed — enter it again once they finish."
          );

          return;
        }
      }

      const acft = await this.focMain.getAircraftData(classCom.aircraftRegistration);

      if (extraMassLoad == -1) {
        const dl = await this.focMain.getDutyLimits(this.getSigningPin());
        extraMassLoad = dl.missionLimits.extraWeight;
      }

      // The arrear is applied only when this call derives the figure itself, and
      // it is the whole outstanding amount, not just this call's burn: nothing
      // reduces `fuelOnBoard_lastSync` on a bail, so subtracting the latest leg
      // alone would leave every earlier bailed one unaccounted and the figure
      // would climb back toward the departure fuel, leg by leg.
      //
      // A caller-supplied figure deliberately does NOT settle it. It would be
      // right to treat one as a gauge reading that supersedes every arrear —
      // but `absFuelLoad != -1` does not identify a reading. `flow-briefing`'s
      // POB sync passes the DISPLAYED value, which is itself `lastSync` minus
      // the running burn, so clearing on it would drop the arrear and leave the
      // fuel figure HIGH. Not clearing costs the opposite error on a genuine
      // reading — the next derived sync subtracts a burn already accounted for,
      // landing LOW — and low is the survivable direction. The real fix is to
      // make the callers say which they mean; see `TODO.md`.
      const arrearApplied = absFuelLoad == -1;
      // Only as much of the arrear as the known fuel can cover, with the rest
      // left owed. Subtracting the whole arrear unfloored LATCHED the service:
      // once it exceeded `fuelOnBoard_lastSync` the derived figure went
      // negative, the guard below rejected it, and because that guard returns
      // without settling, the next leg added its burn to an arrear that could
      // no longer be applied — self-sustaining, and the alert told the crew to
      // re-enter fuel, which takes the caller-supplied branch and does not
      // settle it either. Flooring keeps the derived path always committable.
      const arrearToApply = arrearApplied ? Math.min(this.unappliedFuelBurn, this.fuelOnBoard_lastSync) : 0;
      // True when the burn on the books exceeds the fuel we last knew about, so
      // the committed figure is a FLOOR rather than a running total. Alerted
      // after the commit — silently publishing a 0 nobody entered is the thing
      // to avoid, and by then it is a fact about the state, not a rejection.
      const arrearExceedsFuel = arrearApplied && this.unappliedFuelBurn > this.fuelOnBoard_lastSync;

      if (arrearApplied) {
        absFuelLoad = this.fuelOnBoard_lastSync - arrearToApply;
      }

      // EVERY precondition the recycle needs is checked HERE, before a single
      // value is committed. That ordering is the whole design, and it was
      // learned the hard way over three rounds: `fuelOnBoard_lastSync` and
      // `crashRecovery.setFuelOnBoard` are written first, and the briefing card
      // and map render from `fuelOnBoard_lastSync`, so ANY later bail-out left
      // the crew looking at a NEW fuel figure beside ahead-flight `PERF OK` /
      // `M & B OK` rows still built on the OLD one, with nothing marking them.
      // Bailing out after the commit forces a choice between leaving that
      // stale-green state and destroying a whole duty's calculations — both
      // wrong. Checking first means a failed precondition commits NOTHING,
      // invalidates NOTHING and broadcasts NOTHING to peers.
      //
      // Read that as the three nouns it names, not as "changes nothing" — the
      // arrear booked above is deliberately kept across a bail, which is the
      // whole point of it. Nothing the crew or a peer can see moves; what
      // survives is the record of a burn still owed.
      //
      // So: do not add a `return` below this block, and do not move a check
      // from here into the recycle.

      // Fuel was the one input with no finiteness or lower bound: the capacity
      // check below is one-sided, and `x < undefined` / `x < NaN` are both
      // false, so `undefined`, `NaN` and negatives all passed straight through
      // to `fuelOnBoard_lastSync` and `crashRecovery.setFuelOnBoard`. One live
      // source: a backdrop dismiss of the FOB numpad yields `undefined` (the
      // modal is created without `backdropDismiss: false`). `-1` is the caller
      // sentinel and is substituted above, so it never reaches here.
      //
      // Do NOT read the `< 0` arm as dead just because no caller currently
      // reaches it with a number. It is the last line before
      // `crashRecovery.setFuelOnBoard` and the fleet-wide recycle, and every
      // producer that once fired it is floored at ITS end, not here — the
      // derived substitution above, and `add-edit-flightrecord`, which floors
      // its own pre-fill. Those floors are what keep this arm quiet; unfloor
      // either and it is load-bearing again.
      if (!Number.isFinite(absFuelLoad) || absFuelLoad < 0) {
        await this.alert.showAlert(
          "fuel on board not usable",
          "the fuel-on-board figure is not a usable number. Nothing was changed — enter the fuel on board again."
        );

        return;
      }

      // Reject invalid explicit counts; omitted POB is normalized to -1 below.
      if (pobNbr != null && !Number.isFinite(pobNbr)) {
        await this.alert.showAlert(
          "persons on board not usable",
          "the persons-on-board figure is not a usable number. Nothing was changed — enter the persons on board again."
        );

        return;
      }

      // Omitted POB means preserve each existing flight's stored count.
      // Seat capacity is a limit, never a default passenger count.
      const pobResolved = pobNbr == null || pobNbr === -1 ? -1 : pobNbr;
      if (pobResolved !== -1 && (!Number.isInteger(pobResolved) || pobResolved < MIN_PERSONS_ABOARD)) {
        await this.alert.showAlert(
          "persons on board not usable",
          "Enter a whole persons-on-board count of at least " + MIN_PERSONS_ABOARD + ". Nothing was changed."
        );
        return;
      }
      if (pobResolved !== -1 && pobResolved > acft.nbrSeatsAvail) {
        await this.alert.showAlert(
          "persons on board/seat mismatch",
          "The entered persons-on-board count exceeds the aircraft seat capacity. Nothing was changed."
        );
        return;
      }

      // Same rule: the recycle cannot compute anything without enabled mission
      // types, and it used to discover that AFTER the commit and return on a
      // bare `console.warn` — invisible on iOS. `getOpsMissionTypesOfCurrentDuty`
      // returns `[]` whenever the duty's `parameters` are absent or unparsable,
      // i.e. an unsigned or not-yet-loaded duty, which is a documented state.
      if (this.getOpsMissionTypesOfCurrentDuty().length === 0) {
        await this.alert.showAlert(
          "no mission types",
          "the current duty has no enabled ops mission types, so the calculations cannot be rebuilt. Nothing was changed — sign the duty limits and try again."
        );

        return;
      }

      // An over-capacity entry is REJECTED, not clamped — same rule as the POB
      // above, and for the same reason. Clamping wrote the clamped figure to
      // `fuelOnBoard_lastSync` (so every surface showed a new FOB), skipped
      // `crashRecovery.setFuelOnBoard` (so the PERSISTED value stayed at the
      // pre-clamp figure and came back after a restart), and never ran the
      // recycle at all (so the ahead flights kept rows built on the old FOB and
      // the operator's POB was discarded) — three numbers disagreeing at once.
      if (acft.maxUsableFuelCapacity < absFuelLoad) {
        await this.alert.showAlert(
          "fuel capacity",
          "max fuel capacity of " +
            acft.registration +
            " is " +
            acft.maxUsableFuelCapacity +
            ". Nothing was changed — correct the fuel value and try again."
        );

        return;
      }

      this.fuelOnBoard_lastSync = absFuelLoad;
      if (arrearApplied) {
        // Settle exactly what was applied, never the whole pot: the remainder
        // is burn this figure does NOT account for, and dropping it would put
        // the fuel back on the high side.
        this.unappliedFuelBurn = this.unappliedFuelBurn - arrearToApply;
      } else {
        // A caller-supplied figure SUPERSEDES the arrear. Every producer of one
        // now reads `fuelOnBoardNowKg`, which already has the arrear taken off,
        // so the figure coming back in is a statement about the current fuel
        // and re-subtracting the arrear from it would deduct the same burn
        // twice. This is what makes the arrear escapable: before it, an arrear
        // larger than the fuel could never be applied (`min(arrear, 0)` is 0
        // forever) and no operator action could clear it — the alert below told
        // the crew to enter the actual fuel, and doing so settled nothing.
        //
        // Sound ONLY because the read side is uniform. If any consumer goes
        // back to reading `fuelOnBoard_lastSync` raw and feeding that back,
        // this line silently drops real burn.
        this.unappliedFuelBurn = 0;
      }

      console.log("fuel sync: " + this.fuelOnBoard_lastSync);

      // Caught here, not by the outer handler. Past this line the figure IS
      // committed, so the return value must say so — that is what makes
      // `undefined` mean "nothing was committed" and nothing else, which is the
      // only signal a caller can act on (`flight-timer` records a landing fuel
      // off it). Letting a crash-recovery write failure escape also skipped the
      // ahead-flight recycle, leaving the following flights computed against a
      // fuel figure this service had already moved on from.
      //
      // It is ALERTED, not just logged. `crash-recovery.service.ts` propagates
      // write failures on purpose, so that a stale on-disk value cannot outlive
      // a failed update and be restored at the next boot — and restored it will
      // be, silently, by `getFuelOnBoardFromStorage`. Catching here keeps that
      // stale value in play while the recycle has already rebuilt every ahead
      // flight from the new figure, so the crew has to hear about it: after a
      // restart the displayed fuel and those calculations disagree, with
      // nothing else marking them.
      try {
        await this.crashRecovery.setFuelOnBoard(absFuelLoad);
      } catch (err) {
        console.error("could not persist fuel on board for crash recovery: ", err);
        await this.alert.showAlert(
          "fuel on board not saved",
          "The fuel figure " +
            absFuelLoad +
            " kg is in use and the following flights were recalculated with it, but it could NOT be written to storage. " +
            "If the app restarts before the next fuel sync it will show the previous figure instead. Re-enter the fuel after a restart."
        );
      }

      // Publish the committed figure. The same figure is not sent again.
      const knownFuel = this.aircraftState.knownFuel;
      if (!this.hasFuelRecord || knownFuel?.kg !== absFuelLoad || (knownFuel?.arrear ?? 0) !== this.unappliedFuelBurn) {
        try {
          await this.aircraftState.writeFuel(absFuelLoad, Date.now(), this.unappliedFuelBurn);
          this.hasFuelRecord = true;
        } catch (err) {
          console.error("could not write fuel on board to the aircraft record: ", err);
          await this.alert.showAlert(
            "fuel on board not shared",
            "The fuel figure " +
              absFuelLoad +
              " kg is in use on this device. The other devices of the aircraft keep the old figure until the next fuel sync."
          );
        }
      }

      // Said plainly, and only once the figure is committed: the tracked burn
      // ran past the last fuel we knew about, so what is now in use is a floor,
      // not a measurement. This is NOT a rejection and must not read like one —
      // the crew did nothing wrong, and the earlier version of this state
      // blamed them ("enter the fuel on board again") for an internal
      // accumulator, on a path that re-entering fuel could not clear.
      if (arrearExceedsFuel) {
        await this.alert.showAlert(
          "fuel on board is a lower bound",
          "the flown fuel burn has run past the last fuel figure entered, so " +
            absFuelLoad +
            " kg is being used as a floor rather than a reading. Enter the actual fuel on board when you can."
        );
      }

      // trigger a recalc of all flights that are following.
      //
      // -1 is preserved through to updateMassAndBalance, which reads each flight's POB.
      //
      // `pobResolved`, NOT the raw `pobNbr`. Handing the raw value down meant
      // the caller graded one number and the recycle computed with another: a
      // `NaN` POB (from a stored param string that fails `parseInt`, not from
      // an ordinary numpad cancel) fails `pobNbr >= 0` here, so
      // the caller silently substituted `nbrSeatsAvail` and passed — then the
      // recycle re-derived `NaN`, since `NaN == null`, `NaN < 0` and
      // `NaN > seats` are all false, and hit its own "unreachable" guard after
      // the fuel figure had been committed.
      // Same reason as updateOfpCalculations: the recycle runs the chain once
      // per ahead flight per mission type, and every pass re-reads the same
      // parameter scopes. One cache for the whole recycle, dropped when it
      // ends.
      await paramCache.withParamCache(() =>
        this.udpateFuelMassAndPerfCalcOfAheadFlights(absFuelLoad, extraMassLoad, pobResolved)
      );

      return absFuelLoad;
    } catch (err) {
      console.error("could not fuelsync: " + err);
    } finally {
      await this.publishArrear();
    }
  }

  // A burn booked on a call that did not commit still reaches the other devices.
  // After a commit this is a no-op, because the commit write carried the arrear.
  private async publishArrear(): Promise<void> {
    const known = this.aircraftState.knownFuel;
    // The fuel is this device's committed figure, not the record's: after a failed commit
    // write the record still holds the figure before the burn was taken off.
    const kg = this.fuelOnBoard_lastSync;
    if (!this.hasFuelRecord || !known) return;
    if (known.kg === kg && (known.arrear ?? 0) === this.unappliedFuelBurn) return;
    try {
      await this.aircraftState.writeFuel(kg, Date.now(), this.unappliedFuelBurn);
    } catch (err) {
      console.error("could not write the fuel burn arrear to the aircraft record: ", err);
    }
  }
  async udpateFuelMassAndPerfCalcOfAheadFlights(newFOB: number, newExtraWeight: number, pob: number): Promise<void> {
    // This is the real mutex. The caller no longer rejects on a busy flag — it
    // WAITS — but waiting cannot be airtight: the caller re-checks the flag and
    // then performs several awaits (`getAircraftData`, `setFuelOnBoard`) before
    // reaching this call, so two triggers can still interleave and only one can
    // clear this check. The loser HAS committed a fuel figure by then, so it
    // must not return in silence — the crew would see the new FOB beside
    // ahead-flight rows the winning recycle built on the old one.
    if (this.recycleAheadFlightsBusy) {
      console.log("recycle fuelcalc of ahead flights already running - skipped duplicate trigger");

      await this.alert.showAlert(
        "recalculation already running",
        "the fuel on board was updated, but the ahead-flight calculations were already being rebuilt from an earlier value. Enter the fuel on board again once they finish so the ahead flights match it."
      );

      return;
    }

    this.recycleAheadFlightsBusy = true;
    this.isInProgress.next(true);
    this.progressMessage.next("recycle fuelcalc of ahead flights...");

    // The waiter's gate is created HERE, by the run that actually holds the
    // mutex — never published by the caller. Publishing it caller-side assigned
    // it on every invocation, including one that lost the race above and
    // returned after a `showAlert`; that fast-settling promise overwrote the
    // pointer to the real recycle, so the next waiter woke early, found the
    // flag still set and fell straight through to the bail-out — silently
    // turning the wait back into the reject it replaced.
    let releaseWaiters: () => void = () => undefined;

    this.recycleAheadFlightsPending = new Promise<void>((resolve) => {
      releaseWaiters = resolve;
    });

    try {
      const allFlights = await this.focMain.listAllFlights(new Date(), classCom.activePic, this.MAX_FLIGHTS_QUERY);

      const acft = await this.focMain.getAircraftData(classCom.aircraftRegistration);

      // Keep -1 as "preserve this flight's POB"; never substitute seat capacity.

      const flightsById = new Map<string, flightlistStruct>();

      for (const flight of allFlights) {
        flightsById.set(flight.flightId, flight);
      }

      const briefingRelFlights = await new briefingFlowFeatures().relevantFlights(allFlights, classCom);

      const opsMissionTypes = this.getOpsMissionTypesOfCurrentDuty();

      // DEFENSIVE, same as the POB guard below — the caller checks this before
      // committing the fuel figure, so this should not fire. It is NOT silent
      // if it does: the earlier comment here claimed "nothing has been
      // committed on the path that reaches here", and that was simply wrong —
      // `udpateFuelMassAndPerfCalcOfAheadFlights` has exactly one caller and
      // that caller writes `fuelOnBoard_lastSync` and `crashRecovery` on the
      // line before it calls. Every path into these guards is therefore a
      // post-commit path, and returning quietly leaves the crew with a new FOB
      // beside ahead-flight rows built on the old one. Reachable at all because
      // `currentDutyOfpLimits` is reassigned elsewhere and the caller's check
      // is four awaits earlier.
      if (opsMissionTypes.length === 0) {
        console.warn("No ops mission types found for current duty.");

        await this.alert.showAlert(
          "ahead flight calculations not rebuilt",
          "the fuel on board was updated, but the duty lost its enabled ops mission types before the calculations could be rebuilt, so the ahead flights still show the previous figures. Sign the duty limits and enter the fuel on board again."
        );

        return;
      }

      let fuelRemaining: number = newFOB;

      // Important:
      // Flights must stay sequential because the landing fuel of one flight
      // becomes the fuel input for the next flight. Materialised up front so a
      // failure can invalidate the flights AFTER the failure point — see the
      // stop-and-invalidate block at the end of the loop body.
      const chainFlights = briefingRelFlights
        .map((briefingFlight) => flightsById.get(briefingFlight.flightId))
        .filter(
          (cFlight): cFlight is flightlistStruct =>
            cFlight !== undefined &&
            cFlight.acftReg === classCom.aircraftRegistration &&
            cFlight.actBlocksOffTime === undefined
        );

      // A -1 sentinel preserves the count already stored on each flight.
      if (pob !== -1 && (!Number.isInteger(pob) || pob < MIN_PERSONS_ABOARD)) {
        console.error("recycle reached with an unusable POB (" + pob + ") — caller should have rejected it");

        await this.alert.showAlert(
          "ahead flight calculations not rebuilt",
          "the fuel on board was updated, but the persons-on-board figure was not usable by the time the calculations were rebuilt, so the ahead flights still show the previous figures. Enter the persons on board and the fuel on board again."
        );

        return;
      }

      for (let i = 0; i < chainFlights.length; i++) {
        const cFlight = chainFlights[i];

        // `undefined` = no mission produced a usable landing fuel yet. NOT 0 —
        // 0 is a legitimate (if alarming) landing fuel and collided with the
        // old sentinel, so a real 0 was then RAISED by any later mission.
        let worstLandingFuel: number | undefined = undefined;

        // Collected, not alerted one by one. `alert.showAlert` presents a modal
        // with `backdropDismiss: false` and does not await dismissal, so one
        // alert per mission plus the stop alert handed the crew a stack of
        // modals over the map — on a path `flight-timer.service.ts setTimer`
        // triggers automatically in flight. One flight, one alert.
        const failures: string[] = [];

        // Guarded: `markFlightCalculationsObsolete` is three `namedCommand`
        // writes under `Promise.all`, and `namedCommand` propagates rejections
        // (web: a 500 refused projection or a 503 from `/command`; native: any
        // SQLite fault). Unguarded, that throw unwound to the outer catch and
        // invalidated NOTHING — leaving every flight after this one live on
        // the superseded fuel figure, which is the exact state this stop-and-
        // invalidate exists to remove. `cFlight` is passed as already-stale
        // because its own retirement is the write that just failed — the three
        // tables go out under one `Promise.all`, so it may be partly retired,
        // but it is the flight most likely still showing previous calculations
        // and the crew has to be told.
        if (!(await this.tryInvalidate(cFlight.flightId))) {
          await this.stopChainAndInvalidate(
            chainFlights,
            i,
            "the previous calculations of flight " + cFlight.flightId + " could not be retired",
            [cFlight.flightId]
          );

          break;
        }

        const perfEnvVals = await this.getDutyOfpPerfEnvVars(cFlight.flightId);

        if (!perfEnvVals) {
          // Reachable on a flight that is simply NOT ROUTE-PLANNED YET, which
          // is a normal mid-duty state — `getDutyOfpPerfEnvVars` indexes
          // `navLegs[0]` / `navLegs[length - 2]` with no length check and
          // swallows the TypeError to `undefined`. Stopping is still correct:
          // without that flight's legs its burn is unknown, so every flight
          // after it is unverifiable. The message names the flight to plan,
          // because the invalidated flights have no independent recalculation
          // trigger — planning THIS one is what releases them.
          await this.stopChainAndInvalidate(
            chainFlights,
            i,
            "flight " +
              cFlight.flightId +
              " has no usable route/performance data (is it planned yet?), so the fuel of the flights after it cannot be established",
            [],
            [cFlight.flightId]
          );

          break;
        }

        const fuelPr = new fuelCalcReport();

        const calcResults = await Promise.allSettled(
          opsMissionTypes.map(async ({ str, en }) => {
            const fuel = new fuelFeatures();
            const mandb = new mAndBandPerformance();
            const perf = new performance();

            // Fuel FIRST — same order as `focMain.updateOfpCalculations`, and
            // the only order the data allows. `markFlightCalculationsObsolete`
            // above retires every live fuel / loading / perf row of this flight,
            // and `initMassAndBalance` READS the fuel row: `getTaxiFuel` →
            // `fuelParameterHash` → the `fuelHashAndMassByFlight` catalog entry,
            // which filters `obsolete = 0`. So with mass and balance first there
            // was never a row to read and it failed on every pass.
            //
            // How that failure PRESENTED is worth knowing, because it is not
            // what it looks like. `fuelParameterHash`'s throw never escaped:
            // `initMassAndBalance` catches it and `updateMassAndBalance` catches
            // again, both returning `false`, and this call site discarded the
            // boolean — so mass and balance failing was SILENT. What produced the
            // observed "could not recycle calculation!" alert was
            // `getEstLandingFuel` below, the one call outside any try, on a pass
            // where fuel (which ran last) had also failed. The ordinary pre-fix
            // outcome was a flight with fuel and no W&B or performance, reported
            // as a success. Reproduced on the web SPA 2026-08-14 on a re-sign
            // that recycled an existing flight.
            this.progressMessage.next("Fuel Calculation.. " + en.toUpperCase());

            const fuelOk = await fuel.initFuel(cFlight.flightId, classCom, "", str, fuelRemaining);

            // Each step returns a boolean AND can reject — the two are not
            // alternatives, so both have to be handled. `fuelFeatures.initFuel`
            // has no `try` at all, and its sibling `updateFuel` has one that
            // starts too late: BOTH leave `registration[0].value`,
            // `getAircraftData`, `getPlannedTimesAndDistances` and `getLegs`
            // outside it, and a flight with no navlog row rejects out of either
            // one every time. So do not "simplify" this to `Promise.all` or
            // drop the `rejected` branch below. (The same hazard reaches
            // `updateOfpCalculations`, which awaits `updateFuel` with no catch —
            // out of scope here, recorded in the workspace-root `TODO.md`.)
            //
            // Discarding those booleans is what made the silent-partial outcome
            // above possible, and reordering alone does not close it: with fuel
            // first and healthy, a mass-and-balance failure leaves
            // `getEstLandingFuel` succeeding and the promise FULFILLING, so
            // `Promise.allSettled` reports nothing at all. This call site is a
            // chain owner (fuel → mass and balance → performance), so it owes
            // the same gate `updateOfpCalculations` carries.
            //
            // Retraction of THIS flight's rows is already covered — the pass
            // opens by obsoleting all three tables, so a step that never runs
            // leaves its rows obsolete. What that does NOT cover is the flights
            // AFTER this one, which is what `stopChainAndInvalidate` below is
            // for.
            if (!fuelOk) {
              // Rejecting rather than returning: with no live fuel row, mass and
              // balance would only re-raise `no live fuel calculation …` and
              // performance is gated off behind it, so there is nothing left to
              // compute — and `getEstLandingFuel` below would throw anyway, but
              // without naming the step that actually failed.
              throw new Error("fuel calculation failed for mission " + en + " on flight " + cFlight.flightId);
            }

            this.progressMessage.next("Mass & Balance.. " + en.toUpperCase());

            // A manual POB edit applies only to the next flight. Fuel-only
            // changes and every later flight retain their own recorded POB.
            const wandbOk = await mandb.updateMassAndBalance(
              cFlight.flightId,
              str,
              newExtraWeight,
              "",
              i === 0 ? pob : -1
            );

            // Chain stop. `initPerformance` refuses without a live `loading` row
            // and mass and balance has just retracted its own, so running
            // performance here could only add a second, misleading failure.
            let perfOk = false;

            if (wandbOk) {
              this.progressMessage.next("Performance.. " + en.toUpperCase());

              perfOk = await perf.updatePerformance(
                cFlight.flightId,
                str,
                classCom,
                "",
                perfEnvVals.origin_elev,
                perfEnvVals.dest_elev,
                perfEnvVals.origin_oat,
                perfEnvVals.dest_oat,
                perfEnvVals.origin_qnh,
                perfEnvVals.dest_qnh
              );
            }

            const landingFuel = await fuelPr.getEstLandingFuel(classCom, str, cFlight.flightId);

            // `lastError` is carried out with the step name: the docblock
            // contract at `focMain.ts` `updateMassAndBalance` is that a caller
            // reporting failure to the operator MUST surface it, and on iOS a
            // `console.log` reaches nobody.
            return {
              en,
              landingFuel,
              failedStep: wandbOk ? (perfOk ? undefined : "performance") : "mass and balance",
              failedReason: wandbOk ? perf.lastError : mandb.lastError,
            };
          })
        );

        // EVERY enabled mission must produce a usable landing fuel, because
        // `worstLandingFuel` is a MINIMUM across them: dropping one takes the
        // minimum from the survivors, which can only RAISE it and hand the next
        // flight a more optimistic fuel figure than the aircraft will have. The
        // earlier reading — that a dropped mission is conservative — is true of
        // the surviving missions' own numbers and false of the chain.
        for (const result of calcResults) {
          if (result.status === "rejected") {
            failures.push("a mission failed outright: " + describeError(result.reason));

            continue;
          }

          const { landingFuel, failedStep, failedReason, en } = result.value;

          if (failedStep !== undefined) {
            failures.push(failedStep + " failed for mission " + en + ": " + describeError(failedReason));

            continue;
          }

          // `NaN` passes neither comparison below, so without this guard the
          // first mission's `NaN` was adopted by the `undefined` branch and then
          // propagated into every later flight's fuel input.
          if (!Number.isFinite(landingFuel)) {
            failures.push("mission " + en + " produced no usable landing fuel (" + landingFuel + ")");

            continue;
          }

          if (worstLandingFuel === undefined || landingFuel < worstLandingFuel) {
            worstLandingFuel = landingFuel;
          }
        }

        // Stop and invalidate. The flights after this one have not been
        // recalculated and their existing numbers came from the OLD fuel
        // figure, so leaving them live would display a stale calculation as a
        // current one with nothing marking it. Obsoleting is reversible
        // (`obsolete = 1`, history retained) and the crew recalculates once the
        // missing data is there; `initPerformance`'s liveness guard renders the
        // result as a red `PERF N/A` rather than silence.
        // `worstLandingFuel === undefined` is belt-and-braces: `opsMissionTypes`
        // is non-empty (checked above) and every non-contributing result already
        // pushes a failure, so it cannot fire on its own today. Kept because it
        // is the condition that actually matters — no usable fuel figure.
        if (failures.length > 0 || worstLandingFuel === undefined) {
          // The claim is deliberately limited to the FOLLOWING flights,
          // because this flight's own state VARIES and the message cannot
          // honestly assert one of them. When mass and balance or performance
          // failed, the fuel step already committed and its row is live and
          // valid beside an obsolete loading/perf pair (`PERF N/A`). When the
          // FUEL step failed, `initFuel`'s catch retracted that row too and
          // nothing of this flight survives. Naming the failed step in
          // `failures` is what tells the crew which of the two they have; a
          // blanket "its calculations are invalid" would be wrong in the first
          // case, and a blanket "still valid" wrong in the second. A third
          // shape reaches here too: all three steps succeed and the landing
          // fuel comes back non-finite, where everything is live and valid.
          //
          // Deliberately NO `alreadyCleared` here, unlike the `perfEnvVals`
          // branch. There the sweep is the last word on this flight; here the
          // missions ran afterwards and may have re-committed a fuel row, so
          // the flight is not "invalidated" and listing it as such would be
          // the same false reassurance the `cleared`/`stillLive` split fixed.
          await this.stopChainAndInvalidate(
            chainFlights,
            i,
            "flight " +
              cFlight.flightId +
              " could not be fully recalculated (" +
              failures.join("; ") +
              "), so the following flights' calculations were built on a fuel figure that was never confirmed"
          );

          break;
        }

        fuelRemaining = worstLandingFuel;
      }

      this.TRIGGER_briefing = true;
      this.triggerHandler(false).catch((err) => console.error("triggerHandler: ", err));
    } catch (err) {
      console.error("udpateFuelMassAndPerfCalcOfAheadFlights:", err);

      // `onFlightChange` drops every sync change while the recycle runs, a
      // peer's included, and counts on the recycle to raise the refresh. The
      // success and stop paths raise it after the loop; this path must too.
      this.TRIGGER_briefing = true;

      // `alert.showAlert`, NOT `classCom.promptMessage(…, msgCatStruct.err)`.
      // An err-category prompt LATCHES `classCom.msgErr` (`com.ts`), which is
      // cleared only by `clearMessage()` — and nothing on this path calls it.
      // Twelve `focMain` methods early-return on that flag, including all four
      // actual-time setters, and `flight-timer.service.ts setTimer` reaches the
      // recycle and `setActualArrivalTime` / `setActualBlocksOnTime` in the
      // SAME function. So a prompt here silently refused the landing times.
      await this.alert.showAlert("could not recycle fuel/mass/performance calculations!", describeError(err));
    } finally {
      // Releasing here, not in an inner `finally` before the alert above. An
      // inner one was tried on the theory that a waiter would otherwise be
      // parked behind an operator tap — false: `alert.showAlert` awaits
      // `create` and `present`, never `onDidDismiss`, so no caller has ever
      // blocked on a dismissal. It also would not have covered
      // `stopChainAndInvalidate`, whose alerts are inside the body regardless.
      this.progressMessage.next("");
      this.isInProgress.next(false);
      this.recycleAheadFlightsBusy = false;
      this.recycleAheadFlightsPending = undefined;

      releaseWaiters();
    }
  }

  async alterRoute(acft: aircraftStruct, flightId: string, flightNumber: string): Promise<void> {
    try {
      // The map still shows the flight before this one (`routeDrawPending`).
      // Inside the try, so that the finally still ends the edit mode.
      if (flightId != "" && this.routeDrawPending === flightId) return;
      const currRoute: PointInterface[] = this.routeCtrl.activeRoute.getAllPoints();
      const savedKey = this.shownRouteKey();
      let wrote = false;
      const nav = new navigationalFeatures();

      const config = await this.configCtrl.configP;

      // IMPORTANT: if flightId="" -> this means there is NO created flight yet! in that case change the
      // virgin flight legs variable
      if (flightId == "") {
        // in case its a DCT-TO (currRoute.length=1) we have special case
        // -> need to add the PPOS to the legs, but add

        this.virginFlightLegs = [];

        // this would mean a "DIRECT TO" on the map page
        if (currRoute.length == 1) {
          const ppos: PointInterface = {} as PointInterface;

          ppos.name = "ZZZZ";
          ppos.displayName = "PPOS";
          ppos.id = 0;
          ppos.point = [this.geoLocSer.getGeoInfo().longitude, this.geoLocSer.getGeoInfo().latitude];
          ppos.point.push(500);
          ppos.active = false;
          currRoute.unshift(ppos);

          // set origin to be ppos

          this.virginFlight_origin_geoPos = ppos.point;
          this.virginFlight_dest_geoPos = currRoute[1].point;

          this.addFlightPage_routeFPL = "";
        } else {
          // in this case ppos origin

          // but only if it hase not yet been set
          // map in edit mode is not set on "create OFP from route"
          // thats how we can distinguish
          if (this.MapInEditMode == false) {
            const ppos: PointInterface = {} as PointInterface;

            ppos.name = "ZZZZ";
            ppos.displayName = "PPOS";
            ppos.id = 0;
            ppos.point = [
              this.geoLocSer.getGeoInfo().longitude + 0.00322,
              this.geoLocSer.getGeoInfo().latitude + 0.00322,
            ];
            ppos.point.push(500);
            ppos.active = false;
            currRoute.unshift(ppos);

            // set origin to be ppos
            this.virginFlight_origin_geoPos = ppos.point;
          }

          this.virginFlight_dest_geoPos = currRoute[1].point;

          if (currRoute.length > 0) {
            this.virginFlight_origin_geoPos = currRoute[0].point;
          }

          let avoidDuplicatePoints = []; // this array holds a coordinate string, to avoid duplicated waypoints
          for (let i = 0; i < currRoute.length; i++) {
            const each = currRoute[i];

            const thisLeg: navLegStruct = new navLegStruct();
            thisLeg.geoPos = each.point;
            thisLeg.geoPos.push(500); // needed due 3d mapengine

            thisLeg.ident = each.name;
            thisLeg.desig = each.displayName;

            // that is an ugly hack to determine whether the point is an airport, routhandling doesnt yet support that
            if (i == currRoute.length - 1) {
              if (thisLeg.ident.includes("°")) {
                thisLeg.ident = "ZZZZ";
                thisLeg.desig = "ZZZZ";
              }

              this.virginFlight_dest_geoPos = each.point;
            }

            const thisPointCoordHash = thisLeg.geoPos[0] + "-" + thisLeg.geoPos[1];
            if (avoidDuplicatePoints.includes(thisPointCoordHash) == false) {
              this.virginFlightLegs.push(thisLeg);
              avoidDuplicatePoints.push(thisPointCoordHash);
            }
          }
        }

        // FPL string
        let rteString = "";
        for (let i = 1; i < currRoute.length - 1; i++) {
          const each = currRoute[i];
          if (each.displayName.includes("°") || each.name == "ZZZZ") {
            const coords: string = translateToFplCoordinates(JSON.stringify(each.point));
            rteString += coords + " ";
          } else {
            rteString += each.displayName + " ";
          }
        }

        // remove the last space
        rteString = rteString.slice(0, rteString.length - 1);

        this.addFlightPage_hasUpdated = true; // this will trigger the create flight page to update route

        this.addFlightPage_routeFPL = rteString;

        return;
      } else {
        // change an existing flight
        // halt the trigger
        this.haltTrigger = true;

        try {
          // The endpoint step and the route write queue their parameters, and the
          // leg write sends them with the legs in one flush. One read cache
          // spans both, so the route write sees the queued alternate.
          wrote = await paramCache.withParamCache(async () => {
            const legsOldRead = nav.getLegs(flightId, acft);
            legsOldRead.catch(() => undefined);
            const navLegs: navLegStruct[] = [];
            let navLegsOld: navLegStruct[] = [];

            // only make a change - and trigger all sorts of calculations, if the route really changed
            const routeChanged = async (origin: airportHeliportSearchStruct, dest: airportHeliportSearchStruct) => {
              navLegsOld = await legsOldRead;
              let routePointsNew = "";
              let routePointsOld = "";
              for (let i = 0; i < currRoute.length; i++) {
                const each = currRoute[i];
                const thisLeg: navLegStruct = new navLegStruct();
                thisLeg.geoPos = each.point;
                thisLeg.ident = each.name;
                thisLeg.desig = each.displayName;
                // add data to the legitem, otherwise navlog wont show details correct
                const site = i == 0 ? origin : i == currRoute.length - 1 ? dest : undefined;
                if (site) {
                  thisLeg.desig = site.name;
                  thisLeg.ident = site.icaoCode;
                }
                navLegs.push(thisLeg);
                routePointsNew +=
                  thisLeg.ident + "-" + round(thisLeg.geoPos[0], 1) + "-" + round(thisLeg.geoPos[1], 1) + " ";
              }
              // .length-1 to not include Alternate for the comparison string
              for (let i = 0; i < navLegsOld.length - 1; i++) {
                routePointsOld +=
                  navLegsOld[i].ident +
                  "-" +
                  round(navLegsOld[i].geoPos[0], 1) +
                  "-" +
                  round(navLegsOld[i].geoPos[1], 1) +
                  " ";
              }
              return routePointsNew != routePointsOld;
            };

            // A route needs two points. With fewer, the save failed before too.
            if (currRoute.length < 2) {
              if ((await legsOldRead).length > 1) throw new Error("route has fewer than two points");
              return false;
            }

            let changed = false;
            try {
              const { writes } = await this.focMain.changeRouteEndpoints(
                flightNumber,
                flightId,
                currRoute[0].point,
                currRoute[currRoute.length - 1].point,
                acft,
                // A save that failed after its legs were stored compares as unchanged. It is written again.
                async (origin, dest) =>
                  (changed = (await routeChanged(origin, dest)) || this.routeSaveIncomplete.has(flightId))
              );
              if (!changed) {
                // No leg write follows, so send the endpoint parameters here.
                await execAccuParameters();
                await Promise.all(writes);
                return false;
              }

              // copy existing overfly times, if there are equal points in old an new route!
              for (let o = 0; o < navLegsOld.length - 1; o++) {
                const old = navLegsOld[o].ident;
                for (let n = 0; n < navLegs.length - 1; n++) {
                  if (navLegs[n].ident == old) {
                    navLegs[n].actualTimeOverhead = navLegsOld[o].actualTimeOverhead;
                  }
                }
              }

              // important NOTE:
              // the alternate is always omitted in display in this version. On the other hand when altering
              // the route, we always add the alternate, as the write command deletes all points first.
              try {
                await nav.alterRoute(flightId, navLegs, acft, config.map.terrain.url);
                // A failed alternate or coordinate write fails the save.
                await Promise.all(writes);
                this.routeSaveIncomplete.delete(flightId);
              } catch (err) {
                // The legs can be stored already. The calculations must follow them, and
                // the next map leave must write the inputs again, also for the same route.
                this.routeSaveIncomplete.add(flightId);
                this.TRIGGER_navfeatures = true;
                throw err;
              }
              this.TRIGGER_navfeatures = true;
              return true;
            } finally {
              // A throw ahead of the leg flush must not leave queued inputs for a later, unrelated flush.
              await execAccuParameters().catch((err) => console.error("alterRoute flush: ", err));
            }
          });

          this.routeSaved(flightId, savedKey, wrote);
        } finally {
        }
      }
    } finally {
      this.MapInEditMode = false; // reset immeditately, no case that this could violate
      this.haltTrigger = false;
    }
  }

  // ponytail: in memory only. A reload forgets the mark, and the next real route edit writes everything again.
  /** Flights whose last route save failed after it may have stored the legs. */
  private routeSaveIncomplete = new Set<string>();

  dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  // this function sets the most likely flight
  // --> at a later stage takeoff and landing times might also impact the selection, but not yet
  /** `keepEdits`: draw only while the map shows what the last load drew (`loadedRouteKey`). */
  async setCurrentFlightInMapView(flightId?: string, avoidStorage?: boolean, keepEdits?: boolean) {
    if (avoidStorage == undefined) {
      avoidStorage = false;
    }

    if (this.MapInEditMode) {
      console.log("=auto-timer-start= map is in edit mode");
      return;
    }

    let allFlights = await this.focMain.listAllFlights(new Date(), classCom.activePic);
    let idx: number = -1;

    // check the current flight is still valid:
    let currFlightStorage = { flightId: flightId };

    if (flightId == undefined && avoidStorage == false) {
      try {
        const stored = await this.crashRecovery.getLastFlightLoaded();
        if (stored) currFlightStorage = { flightId: stored.flightId };
      } catch (err) {}
      // check the current flight has landed:
      for (let i = 0; i < allFlights.length; i++) {
        if (currFlightStorage.flightId == allFlights[i].flightId && currFlightStorage.flightId !== undefined) {
          if (allFlights[i].actBlocksOnTime == undefined) {
            idx = i;
            break;
          }
        }
      }
    }

    console.log("=auto-timer-start= pos2");

    if (flightId !== undefined) {
      // check the current flight has landed:
      for (let i = 0; i < allFlights.length; i++) {
        if (flightId == allFlights[i].flightId && flightId !== undefined) {
          if (allFlights[i].actBlocksOnTime == undefined) {
            idx = i;

            console.log("=auto-timer-start= pos3 " + i);
            break;
          }
        }
      }

      // if the selected flight is a historic one, go ahead looking all historic ones:
      console.log("=auto-timer-start= pos4 " + idx);
      if (idx == -1) {
        // if flight is set, also historc flights should be displayed (missing the actblockTime part)
        // see: we use the optional parameter, to only fetch that flight with that id
        const historicFlight = await this.focMain.listAllFlights(
          new Date(),
          classCom.activePic,
          this.MAX_FLIGHTS_QUERY,
          flightId
        );

        idx = 0;
        allFlights = historicFlight;
      }
    }

    // if index not yet set:
    console.log("=auto-timer-start= pos5 " + idx);
    if (idx == -1) {
      // for the time beeing take the first flight in briefing

      let minTime: number = 0;

      // check how many flights there are ahead, if there is only one,
      // ignore the time limitation

      let flightsAhead: number = 0;
      let onlyOneFlight_idx: number = 0;
      for (let i = 0; i < allFlights.length; i++) {
        const flight: flightlistStruct = allFlights[i];

        // check est dep / arr time is within the last 90 min
        // but only applies if one active flight in the pipline
        const plannedDepartureDiff: number = new Date().getTime() - flight.estTimeDep.getTime();
        const allowMinOfDelay_oneFlightOnly: number = 90 * 60 * 1000;

        if (Math.abs(plannedDepartureDiff) < allowMinOfDelay_oneFlightOnly) {
          if (flight.actBlocksOnTime == undefined) {
            flightsAhead += 1;
            onlyOneFlight_idx = i;
          }
        }
      }

      if (flightsAhead == 1) {
        idx = onlyOneFlight_idx;
        console.log("only one flight to consider: idx = " + idx);
      }

      // this identifies a flight under many (using normal filters)
      for (let i = 0; i < allFlights.length; i++) {
        const flight: flightlistStruct = allFlights[i];
        try {
          if (flight.actBlocksOnTime == undefined) {
            // check not yet departed (or arrived)

            // check ebot within 30 min
            const eobt: number = flight.estTimeDep.getTime();

            const now = new Date().getTime();

            const dif = eobt - now;
            const Seconds_from_T1_to_T2 = dif / 1000;
            const Seconds_Between_Dates = Math.abs(Seconds_from_T1_to_T2);

            const timeMargin: number = 60 * 30;

            if (Seconds_Between_Dates < timeMargin) {
              if (dif < minTime || minTime == 0) {
                minTime = dif;
                idx = i;
              }
            }
          }
        } catch (err) {
          console.log("could read that flight: " + JSON.stringify(flight));
        }
      }
    }

    console.log("=auto-timer-start= pos6 " + idx);
    if (idx !== -1) {
      const registration: string = (
        await getParameter(allFlights[idx].flightId, "flightlist", property.acftReg, opsMissionTypeEnum.all)
      )[0].value;
      const acft: aircraftStruct = await this.focMain.getAircraftData(registration);
      const flight = allFlights[idx];
      return this.flightLoaded(
        flight.flightId,
        flight.flightNumber,
        await this.setRouteInMapview(flight.flightId, flight.flightNumber, acft, keepEdits),
        keepEdits
      );
    } else {
      console.log("=auto-timer-start= pos7 " + idx);
      // save in storage (case of app relaunch):
      try {
        await this.crashRecovery.setLastFlightLoaded({
          flightId: "",
          flightNumber: "",
        });
      } catch (err) {
        console.error("could not clear restart_lastFlightLoaded: ", err);
      }
      this.triggerHandler(true).catch((err) => console.error("triggerHandler: ", err));
      this.clearMapFlight();

      this.displayMapMessage("no OFP avail");

      return false;
    }
  }

  /**
   * The end of a map load. A load that did not get the map (`gotMap` false) is
   * not the last flight loaded: the map still shows the flight before it, and
   * the caller hears `false`, so it can retry or say so. A sync reload
   * (`keepEdits`) records nothing either: it does not change which flight is
   * loaded, and the timer stop clears the record while the landed flight stays
   * on the map, so a reload must not put that flight back for the next timer.
   */
  private async flightLoaded(
    flightId: string,
    flightNumber: string,
    gotMap: boolean,
    keepEdits?: boolean
  ): Promise<boolean> {
    if (!gotMap) return false;

    // save in storage (case of app relaunch):
    if (!keepEdits) {
      try {
        await this.crashRecovery.setLastFlightLoaded({ flightId, flightNumber });
      } catch (err) {
        console.error("could not store restart_lastFlightLoaded: ", err);
      }
    }

    // let flow-briefing refresh (when go back to flow-briefing page, everything already updated..)
    this.TRIGGER_briefing = true;
    return true;
  }

  /**
   * Loads a flight's route and draws it 1 s later. A load the crew asked for
   * takes the map when its read answers (flight id, number, aircraft), unless
   * the read is empty or old, or the crew asked for another flight after it.
   * A sync reload (`keepEdits`) never takes it: it draws only the flight that
   * owns the map. Answers whether this flight has the map after the read.
   * Everything else (planned route, header, points) goes on the map in the
   * delayed draw, and only when `mayDrawRoute` allows it, so a load that is
   * refused leaves the map as it was.
   */
  async setRouteInMapview(
    flightId: string,
    flightNumber: string,
    aircraft: aircraftStruct,
    keepEdits?: boolean
  ): Promise<boolean> {
    this.progressMessage.next("loading navpage..");

    // the aircraft is needed in order to find a new destination (based on geo pos)
    // we need the aircraft to clarify whether or not heliports are approrpate
    const acft = aircraft ?? this.currMapServiceAircraft;

    // ops control sets the flight using this function: the mapText parameter will be displayed on the
    // central-top mapdesignator (that isually writes the direct to points)
    const nav = new navigationalFeatures();
    console.log("loading navpage.. #2");
    const seq = ++this.routeLoadSeq;
    const saves = this.routeSaves;
    if (!keepEdits) this.routeCrewLoad = { seq, flightId };
    const navLegs = await nav.getLegs(flightId, acft);

    // The crew asked for another flight after this load. The newer load takes
    // the map, also when this read answers last, and it owns the progress
    // message. Two loads of one flight are ordered by `routeReadIsOld`.
    const newest = this.routeCrewLoad;
    if (!keepEdits && seq < newest.seq && newest.flightId !== flightId) return this.currentEditFlightId === flightId;

    // A route edit opened during the read owns the map now. So does another
    // flight, for a sync reload. A failed read answers no legs: none of these
    // takes the map.
    if (this.MapInEditMode || (keepEdits && this.currentEditFlightId !== flightId) || navLegs.length < 2) {
      this.progressMessage.next("");
      return false;
    }
    // A read older than the last draw of this flight is stale and takes
    // nothing. The flight has the map when that newer draw is still shown.
    if (this.routeReadIsOld(flightId, seq)) {
      this.progressMessage.next("");
      return this.currentEditFlightId === flightId;
    }

    console.log("loading navpage.. #3");
    if (!keepEdits) {
      if (this.currentEditFlightId !== flightId) this.routeDrawPending = flightId;
      this.currentEditFlightId = flightId;
      this.currMapServiceFlightNumber = flightNumber;
      this.currMapServiceAircraft = acft;
    }
    const pts: PointInterface[] = [];

    const id = new Date().getTime();

    // due the mapengines bloody beginnings, we have to check there are no duplicated geoPos points,
    // otherwise the mapengine will play bananas

    // eslint-disable-next-line camelcase
    const geoPos_avoidDup: string[] = [];

    // important NOTE:
    // the alternate is always omitted in display in this version. We�ll find a better solution longterm!
    // thats why it says ".length-1"

    // !! important
    // find the first active point (and not set not overflew points again)
    let lastActivePointIdx: number = 0;
    for (let i = 0; i < navLegs.length - 1; i++) {
      // loop from behind
      let q = navLegs.length - 1 - i;
      if (navLegs[q].actualTimeOverhead == 0) {
        lastActivePointIdx = q;
      } else {
        break;
      }
    }
    console.log("loading navpage.. #4");
    const planned: PointInterface[] = [];

    // on the other hand when altering the route, we�ll have to always add the alternate, as the write command
    // deletes alle points first.
    for (let i = 0; i < navLegs.length - 1; i++) {
      const each = navLegs[i];

      try {
        // hack to avoid PPOS collisions :(
        each.geoPos[0] += 0.00001;
        each.geoPos[1] += 0.00001;

        const fplPt: PointInterface = {
          id: id + i,
          name: each.ident,
          displayName: each.ident,
          point: each.geoPos,
          active: each.actualTimeOverhead == 0,
        };

        if (i < lastActivePointIdx) {
          fplPt.active = false;
        }

        if (!geoPos_avoidDup.includes(each.geoPos[0] + "-" + each.geoPos[1])) {
          pts.push(fplPt);
          geoPos_avoidDup.push(each.geoPos[0] + "-" + each.geoPos[1]);

          // assamble the planned route object here
          planned.push(fplPt);
        }

        // assamble the planned route object here
        planned.push(fplPt);
      } catch (err) {}
    }

    console.log("loading navpage.. #5");

    // what a ugly hack, but the mappage doesnt work otherwise
    // in the current setup :(
    const ff = this.routeCtrl.activeRoute;

    try {
      const destLeg = navLegs[navLegs.length - 2]; // -2 to ignore alternate
      const name = destLeg.ident + " \n " + destLeg.desig;

      // this timeout is due türtscher shit
      setTimeout(() => {
        try {
          if (this.routeDrawPending === flightId) this.routeDrawPending = "";
          if (!this.mayDrawRoute(flightId, seq, saves, keepEdits)) {
            this.progressMessage.next("");
            return;
          }
          ff.setName(name);
          this.currMapFlight_plannedRoute = planned;
          this.routeCtrl.activeRoute.replaceWith(pts);
          try {
            this.routeCtrl.setRouteActive(planned); // to not have the bloody line from ppos to the planning route
          } finally {
            this.progressMessage.next("");
          }

          // set the route header field
          this.routeCtrl.activeRoute = ff;
          this.loadedRouteKey = this.shownRouteKey();
          this.routeDrawn.set(flightId, seq);
        } finally {
          this.isInProgress.next(false);
        }
      }, 1000);
    } catch (err) {
      // No draw will come, so do not hold the map-leave save back.
      if (this.routeDrawPending === flightId) this.routeDrawPending = "";
    }
    return true;
  }

  async getAllActiveRouteStrings(): Promise<RouteType[]> {
    const allFlightList = await this.focMain.listAllFlights(new Date(), classCom.activePic);

    const now = new Date().getTime();

    const timeMarginArr: number = 20 * 60000;

    let routes: RouteType[] = [];
    // The legs of all active flights start together: on web each read is a round trip.
    const legsOf = allFlightList.map((f) =>
      f.estTimeArr.getTime() + timeMarginArr > now
        ? new navigationalFeatures().getLegs(f.flightId, this.currMapServiceAircraft)
        : undefined
    );
    await Promise.all(legsOf);
    for (let i = 0; i < allFlightList.length; i++) {
      if (allFlightList[i].estTimeArr.getTime() + timeMarginArr > now) {
        const navLegs = await legsOf[i];

        const rt: RouteType = {
          start: [0, 0],
          end: [0, 0],
          waypoints: [],
          name: allFlightList[i].icaoOrigin + "-" + allFlightList[i].icaoDest,
        };

        rt.start = [navLegs[0].geoPos[0], navLegs[0].geoPos[1]];
        rt.end = [navLegs[navLegs.length - 2].geoPos[0], navLegs[navLegs.length - 2].geoPos[1]];
        for (let i = 0; i < navLegs.length - 1; i++) {
          const intermed_p: Point = [navLegs[i].geoPos[0], navLegs[i].geoPos[1]];
          rt.waypoints.push(intermed_p);
        }

        routes.push(rt);
      }
    }

    console.log("=ooovvv= " + JSON.stringify(routes));

    return routes;
  }

  clearMapFlight() {
    // this function clears the active route from mapview
    this.routeCtrl.activeRoute.setName("no active OFP");
    this.routeCtrl.setRouteActive();
  }

  // duty check
  public dutyLimitsTrigger = new Subject<Boolean>();

  /**
   * The run a new asker may reuse, or undefined. On web a page entry, the
   * ticker and the update subscription each ask within the same seconds, and
   * each answer is a dozen requests. A run is reused only when it started for
   * the same key less than RUN_SHARE_MS ago and nothing was written or synced
   * since it started: then a new run would read the same rows. Native never
   * reuses: its writes do not move the write count, so nothing proves that.
   */
  private joinRun<T>(run: SharedRun<T> | undefined, key: string): Promise<T> | undefined {
    if (!run || this.platformAdapter.isNative) return undefined;
    if (run.key !== key || run.generation !== userReadCache.writeGeneration()) return undefined;
    if (Date.now() - run.startedAt > RUN_SHARE_MS) return undefined;
    return run.promise;
  }

  private startRun<T>(key: string, work: () => Promise<T>): SharedRun<T> {
    // The count is read before the work starts, so a write the work races is counted.
    const generation = userReadCache.writeGeneration();
    const run: SharedRun<T> = { promise: work(), key, startedAt: Date.now(), generation };
    // A failed run answers nobody else.
    run.promise.catch(() => (run.startedAt = -Infinity));
    return run;
  }

  private dutyCheckRun: SharedRun<boolean> | undefined;

  /**
   * Checks the signed duty and fires `dutyLimitsTrigger`. A caller that reuses
   * a run fires the trigger again when it settles: the page that asked may
   * have subscribed after the first run fired it, and the card load that
   * follows is itself reused.
   */
  checkDutyLimitsValid(): Promise<boolean> {
    const key = classCom.aircraftRegistration + "|" + this.getSigningPin();
    const shared = this.joinRun(this.dutyCheckRun, key);
    if (shared) {
      return shared.finally(() => this.dutyLimitsTrigger.next(true));
    }
    this.dutyCheckRun = this.startRun(key, () => paramCache.withParamCache(() => this.runDutyCheck()));
    return this.dutyCheckRun.promise;
  }

  private async runDutyCheck(): Promise<boolean> {
    if (classCom.aircraftRegistration == "") return;
    if (classCom.aircraftRegistration == "OENWY") return;

    const authInf = await this.auth.getLoginInformation_device();
    if (!authInf?.registration || authInf.registration.length < 4) return; // this means there is no config set (aircraft registration -> app) or user login (username ->pwa)

    this.progressMessage.next("check duties for " + classCom.aircraftRegistration);

    try {
      let valid: boolean = false;
      const signingPin: string = this.getSigningPin();
      if (signingPin) {
        valid = await this.focMain.getDutyLimitsIfAlreadySignedAndStillvalid(signingPin);
      }
      const acft: aircraftStruct = await this.focMain.getAircraftData(classCom.aircraftRegistration);

      if (acft == undefined) {
        // Leaves `typeOfDuty` unassigned, which sends duty-ofp-limits into its
        // managed-crew branch and hides the ad-hoc UI. Silent until now — say
        // why, because the cause is data (a tail that isn't in fpp_acftData),
        // not a code path anyone can reach from the UI.
        console.warn(
          `[dutyLimits] no fleet aircraft "${classCom.aircraftRegistration}" in fpp_acftData — ` +
            "duty type stays unset and the ad-hoc duty UI will not offer itself. " +
            "Check the registration against the aircraft-controller update data."
        );
        return;
      }

      this.registration = acft.registration;
      this.acftType = acft.model;

      let timefs = new Date().getTime();
      let flightCrew = await this.focMain.getCurrentFlightCrew(timefs, classCom.aircraftRegistration);

      if (flightCrew !== undefined) {
        if (flightCrew.length > 0) {
          // this means managed crew avail
          // .......................
          // set the type to managed

          let overrideCrewAvail: boolean = false;
          let managedCrewAvail: boolean = false;
          this.duty_has_changes = false; //Reset that one:
          for (let i = 0; i < flightCrew.length; i++) {
            const thecrew = flightCrew[i];

            if (thecrew.dutyId == "0") {
              overrideCrewAvail = true;
            }

            if (thecrew.dutyId !== "0") {
              managedCrewAvail = true;
            }
          }

          if (managedCrewAvail) {
            this.typeOfDuty = dutyTypeEnum.managed_avail;
            this.duty_has_changes = overrideCrewAvail;
          } else {
            if (overrideCrewAvail) {
              this.typeOfDuty = dutyTypeEnum.adhoc_only;
            }
          }
        } else {
          // this means ad-hoc crew (unmanaged)
          // ..................................
          // set the type to managed
          this.typeOfDuty = dutyTypeEnum.adhoc_only;
        }
        for (let i = 0; i < flightCrew.length; i++) {
          // always take the newer pilot (the last entry) -displayed primary on the login page
          this.currentDutyPic = flightCrew[i].pilotsAboard;
          this.currentDutyCrew = flightCrew[i].dutyDesig;
        }

        if (valid) {
          // `getDutyLimits` returns undefined on a miss. FAIL CLOSED — a
          // previous cut only guarded the first three assignments and left four
          // more `dl.*` dereferences below, so the TypeError still escaped
          // through this function's `finally`-without-`catch` into
          // `duty-ofp-limits.initialize()`, which awaits it bare and aborts with
          // `isProgress` stuck true (permanent progress bar, unsignable page).
          //
          // The miss is reachable whenever the validity probe and this fetch
          // disagree. One named cause is closed: `getDutyLimitsIfAlreadySigned-
          // AndStillvalid` used to cache on the aircraft registration and NOT on
          // the pin, so a latch warmed under one pin reported valid for another.
          // It keys on the ident now. Keep the guard: it fails closed, and the
          // probe and the fetch remain two separate reads.
          //
          // Clearing the three display fields matters: they render as a
          // signature attestation ("commander {{ pic }} ({{ signature }})") and
          // `dutyLimitsTrigger` fires from the `finally` regardless, so leaving
          // them would publish the PREVIOUS duty's commander under this one.
          const dl: dutyAuthStruct = await this.focMain.getDutyLimits(this.getSigningPin());
          if (dl === undefined) {
            this.pic = "";
            this.crewDesig = "";
            this.signature = "";
            this.currentDutyOfpLimits = undefined;
            return false;
          }

          this.pic = dl.pilotInCommand;
          this.crewDesig = dl.crewDesignator;
          this.signature = dl.signature;

          // store the current duty as class variable
          this.currentDutyOfpLimits = dl;

          // Last match wins, which is what every other surface resolves -- see
          // `currentSignatureId` and `fccProvider.getDutyIdOfFlight`. The loop this
          // replaced kept the last match too, but left the previous duty's values in place
          // when nothing matched, so a stale commander and homebase were published under
          // the new duty.
          const matchedDuty = flightCrew.filter((crew) => crew.dutyDesig === dl.crewDesignator).pop();
          classCom.activeDutyId = matchedDuty?.dutyId;
          classCom.activeDutyDesig = matchedDuty?.dutyDesig;
          classCom.activePic = matchedDuty?.pilotsAboard;
          classCom.activeHomebaseIdent = matchedDuty?.homeBaseIdent;

          // The crew that signed the duty is gone. Send the operator back to sign again
          // and STOP -- everything below reads `dl` and the active* fields as a matched
          // pair, so continuing publishes a duty nothing on this device stands behind.
          if (!matchedDuty) {
            if (this.router.url == "/flow-briefing") {
              this.navCtrl.navigateForward("/duty-ofp-limits").catch((err) => console.error("navigateForward: ", err));
            }
            return false;
          }

          this.crewDesig = matchedDuty.dutyDesig;

          let missionTypes_string: string = "ops-Mission-types: ";
          let limitsDesig_string: string = "";

          const opsTypes: string[] = parseCss(dl.parameters, "opsMissionType")
            .replace("[", "")
            .replace("]", "")
            .split(",");

          for (let i = 0; i < opsTypes.length; i++) {
            missionTypes_string += opsTypes[i].toUpperCase() + ", ";
          }

          missionTypes_string = missionTypes_string.slice(0, missionTypes_string.length - 2);
          limitsDesig_string +=
            dl.missionLimits.extraFuel +
            " kg extra fuel   -   " +
            dl.missionLimits.extraWeight +
            " kg extra mass   -    " +
            dl.missionLimits.standardFuel +
            " kg standard fuel ";

          this.missionTypesSelected = missionTypes_string;
          this.limitsDesignator = limitsDesig_string;
        }

        if (!valid) {
          if (flightCrew.length == 0) {
            return true;
          } else {
            if (this.focMain.targetPlatform == targetPlatformEnum.na) {
              // if not registered (what a ugly hack)
              if (authInf.registration.length < 4) {
                // do nothing
              } else {
                if (this.router.url == "/flow-briefing") {
                  this.navCtrl.navigateRoot("/duty-ofp-limits").catch((err) => console.error("navigateRoot: ", err));
                }
              }
            } else {
              // only if shifts are available, switch the page
              if (this.authS.authLogin_user) {
                if (this.router.url == "/flow-briefing") {
                  this.navCtrl.navigateRoot("/duty-ofp-limits").catch((err) => console.error("navigateRoot: ", err));
                }
              }
            }
          }

          return valid;
        }
      }
      return valid;
    } finally {
      // set the base mission
      this.missionService.useBaseForMisssion = classCom.activeHomebaseIdent;

      this.isInProgress.next(false);
      this.progressMessage.next("");

      this.dutyLimitsTrigger.next(true);
    }
  }

  // this is the scaling of the flow briefing milage (to pixel)
  public pixelDistanceFactor: number = 0.01;
  private flowBriefingBottomMargin_px: number = 370;

  // update finished
  public async renewBriefings() {
    try {
      // One run for the list and the checks, so the checks read the params the
      // list already loaded instead of three requests per flight. The updates
      // stay outside the run, as before: they write.
      const due = await paramCache.withParamCache(async () => {
        const allFlightList = await this.focMain.listAllFlights(new Date(), classCom.activePic);
        const out: flightlistStruct[] = [];
        for (const cFlight of allFlightList) {
          // check if we need to create a new revision of breefing docs
          if ((await this.focMain.checkNewBriefingCreationRequired(cFlight)) === true) out.push(cFlight);
        }
        return out;
      });

      for (const cFlight of due) {
        this.progressMessage.next(
          "updating briefing for: " + cFlight.flightNumber + " " + cFlight.icaoOrigin + " - " + cFlight.icaoDest
        );
        await this.focMain.updateBriefingDocuments(cFlight.flightId);
      }
    } catch (err) {
      console.log("ops-ctrl-ser:couldnt get flightlist! " + err);
      return false;
    } finally {
      // Always clear the "updating briefing for: …" bar — a throw mid-loop must
      // not freeze it forever (mirrors the recompute clear at isInProgress/1507).
      this.progressMessage.next("");
    }
  }

  // as those need more space

  /**
   * The card data. The ticker, a page entry and the duty-check trigger often
   * ask within the same seconds, and each load is a full set of reads plus the
   * terrain profiles, so they share one run (`joinRun`). The key is the PIC:
   * the duty check sets it, and a load that started before it changed lists
   * another PIC's flights.
   */
  private loadBriefingData(): Promise<briefgFlowFlightStruct[]> {
    const pic = classCom.activePic;
    const key = String(pic);
    const shared = this.joinRun(this.briefingDataRun, key);
    if (shared) return shared;
    this.briefingDataRun = this.startRun(key, async () => {
      const config = await this.configCtrl.configP;
      return loadBriefingCard(() => this.focMain.listAllFlights(new Date(), pic, this.MAX_FLIGHTS_QUERY), classCom, {
        webcamLiveUrl: this.webcamLiveUrl,
        webcamToolId: config.webcamToolId,
        weatherToolId: config.weatherToolId,
        position: [this.geoLocSer.geoInfo.longitude, this.geoLocSer.geoInfo.latitude],
      }).then((flights) =>
        addRouteDocuments(flights, this.routeDocumentDb, this.routeDocumentFs, [
          ...config.documentToolId,
          config.briefingToolId,
          ...(config.documentChannels ?? []).map((c) => c.toolId),
        ])
      );
    });
    return this.briefingDataRun.promise;
  }

  private briefingDataRun: SharedRun<briefgFlowFlightStruct[]> | undefined;

  public async getRouteBriefingDocuments(): Promise<{ title: string; address: string; toolId: number }[]> {
    const flights = await this.loadBriefingData();
    const documents: { title: string; address: string; toolId: number }[] = [];
    const seen = new Set<string>();
    for (const flight of flights) {
      for (const entry of flight.briefingContent) {
        if (entry.type !== briefgFlowContentEnum.doc) continue;
        const [, title, , address, toolId] = entry.parameters;
        const key = `${toolId}:${address}`;
        if (seen.has(key)) continue;
        seen.add(key);
        documents.push({ title, address, toolId });
      }
    }
    return documents;
  }

  async loadFlowBrfg(avoidReloading: boolean): Promise<briefgFlowComponentStruct[]> {
    let incBottomMargin_lastY: number; // this is set by the webcam setter to see at the end wheter inc bottom margin is required
    let lastY_lastPointInProgressPanel: number;

    let localList: briefgFlowComponentStruct[] = [];

    // there are cases where we dont want to reload:
    // this is e.g. the case, when user collapses one of the panels
    if (avoidReloading == false) {
      try {
        this.flowBriefingData = await this.loadBriefingData();
      } catch (err) {
        console.log("ops-ctrl-ser:couldnt get flowBriefingData! " + err);
        return [];
      }
    }

    localList = [];
    try {
      if (this.flowBriefingData == null) return;
      const data: briefgFlowFlightStruct[] = this.flowBriefingData;

      for (let i = 0; i < data.length; i++) {
        // dynamic pixelDistanceFactor (to avoid small overlaps on waypoints)
        if (data[i].trackDistAndAlternate < 30000) {
          this.pixelDistanceFactor = 0.02;
        } else {
          this.pixelDistanceFactor = 0.01;
        }

        // avoid duplication array
        const avoidDupl: string[] = [];

        const Q = new briefgFlowComponentStruct();
        Q.data = data[i];
        // left route side
        Q.progress_label = [];

        try {
          Q.progress_inner = "height:" + Math.round(data[i]._progress * this.pixelDistanceFactor) + "px";
        } catch (err) {
          console.log("warn:could not calc trackball!");
        }

        for (let l = 0; l < data[i].route.length; l++) {
          const npl = new briefgFlowProgLabelStruct();
          npl.desig = data[i].route[l].desig;
          npl.descr = data[i].route[l].remark;

          npl.desigStyle = "top:" + (25 + Math.round(data[i].route[l].trackDist * this.pixelDistanceFactor)) + "px";

          // this is to determin whether or not we need more space for the last webcam group
          lastY_lastPointInProgressPanel =
            this.flowBriefingBottomMargin_px + (25 + Math.round(data[i].route[l].trackDist * this.pixelDistanceFactor));

          Q.progress_label.push(npl);
        }

        // right content side
        Q.briefingContent = [];
        Q.gapfiller = [];

        let npl = new briefgFlowProgLabelStruct();
        npl.desig = "";
        npl.descr = "";

        let currentGroupStarted_Y: number = 0;
        let currentGroupEnd_Y: number = 0;
        const groupCoverage: number = 250 / this.pixelDistanceFactor; // as most boxes are 150 high
        const offset = -20; // offset that the entire webcam grouping shifts

        // first ending:
        if (data[i].briefingContent.length > 0) {
          // check there are results
          currentGroupStarted_Y = data[i].briefingContent[0].trackDist;
          currentGroupEnd_Y = currentGroupStarted_Y + groupCoverage;
          npl.images = [];
          npl.documents = [];
          npl.descr = "";
          npl.desigStyle = "top:" + Math.round(offset + currentGroupStarted_Y * this.pixelDistanceFactor) + "px;";
          npl.trackDistMeters = currentGroupStarted_Y;

          // gap filler
          let lastElementY: number = 0;
          for (let l = 0; l < data[i].briefingContent.length; l++) {
            const elemY: number = Math.round(data[i].briefingContent[l].trackDist);
            if (elemY >= currentGroupStarted_Y && elemY < currentGroupEnd_Y) {
              // images
              if (data[i].briefingContent[l].type == briefgFlowContentEnum.webcam) {
                // to avoid duplications
                if (!avoidDupl.includes(data[i].briefingContent[l].parameters[2].toString())) {
                  npl.images.push({
                    url: data[i].briefingContent[l].parameters[0],
                    rteOffset: data[i].briefingContent[l].parameters[1],
                    id: data[i].briefingContent[l].parameters[2],
                    lowQimg: data[i].briefingContent[l].parameters[3],
                    age_min: data[i].briefingContent[l].parameters[4],
                    cssAge: data[i].briefingContent[l].parameters[5],
                  });
                  lastElementY = elemY + groupCoverage;

                  incBottomMargin_lastY = lastElementY;

                  avoidDupl.push(data[i].briefingContent[l].parameters[2].toString());
                }
              }

              if (data[i].briefingContent[l].type == briefgFlowContentEnum.doc) {
                const doc = data[i].briefingContent[l];
                if (!avoidDupl.includes(doc.parameters[2])) {
                  npl.documents.push({
                    html: doc.parameters[0],
                    title: doc.parameters[1],
                    address: doc.parameters[3],
                    toolId: doc.parameters[4],
                  });
                  avoidDupl.push(doc.parameters[2]);
                  lastElementY = elemY + groupCoverage;
                  incBottomMargin_lastY = lastElementY;
                }
              }

              // metar
              if (data[i].briefingContent[l].type == briefgFlowContentEnum.metar) {
                // to avoid duplications
                if (!avoidDupl.includes(data[i].briefingContent[l].parameters[0].toString())) {
                  npl.descr += data[i].briefingContent[l].parameters[0].toString() + "</br>";
                  npl.ageCss = data[i].briefingContent[l].parameters[2].toString();
                  npl.age_min = data[i].briefingContent[l].parameters[1].toString();
                  lastElementY = elemY + groupCoverage;

                  avoidDupl.push(data[i].briefingContent[l].parameters[0].toString());
                }
              }
            } else {
              // push the panel, as a transition is indicated with this else:
              // remove the last linebreak in desc (cosmetics only)
              npl.descr = npl.descr.substring(0, npl.descr.length - 5);

              Q.briefingContent.push(npl);
              npl = new briefgFlowProgLabelStruct();
              npl.desigStyle = "top:" + (offset + Math.round(elemY * this.pixelDistanceFactor)) + "px;";
              npl.trackDistMeters = data[i].briefingContent[l].trackDist;
              npl.images = [];
              npl.documents = [];
              npl.descr = "";

              currentGroupStarted_Y = data[i].briefingContent[l].trackDist;
              currentGroupEnd_Y = currentGroupStarted_Y + groupCoverage;

              // images
              if (data[i].briefingContent[l].type == briefgFlowContentEnum.webcam) {
                // to avoid duplications
                if (!avoidDupl.includes(data[i].briefingContent[l].parameters[2].toString())) {
                  npl.images.push({
                    url: data[i].briefingContent[l].parameters[0],
                    rteOffset: data[i].briefingContent[l].parameters[1],
                    id: data[i].briefingContent[l].parameters[2],
                    lowQimg: data[i].briefingContent[l].parameters[3],
                    age_min: data[i].briefingContent[l].parameters[4],
                    cssAge: data[i].briefingContent[l].parameters[5],
                  });
                  lastElementY = elemY + groupCoverage;

                  incBottomMargin_lastY = lastElementY;

                  avoidDupl.push(data[i].briefingContent[l].parameters[2].toString());
                }
              }

              if (data[i].briefingContent[l].type == briefgFlowContentEnum.doc) {
                const doc = data[i].briefingContent[l];
                if (!avoidDupl.includes(doc.parameters[2])) {
                  npl.documents.push({
                    html: doc.parameters[0],
                    title: doc.parameters[1],
                    address: doc.parameters[3],
                    toolId: doc.parameters[4],
                  });
                  avoidDupl.push(doc.parameters[2]);
                  lastElementY = elemY + groupCoverage;
                  incBottomMargin_lastY = lastElementY;
                }
              }

              // metar
              if (data[i].briefingContent[l].type == briefgFlowContentEnum.metar) {
                // to avoid duplications
                if (!avoidDupl.includes(data[i].briefingContent[l].parameters[0].toString())) {
                  npl.descr += data[i].briefingContent[l].parameters[0].toString() + "</br>";
                  npl.ageCss = data[i].briefingContent[l].parameters[2].toString();
                  npl.age_min = data[i].briefingContent[l].parameters[1].toString();
                  lastElementY = elemY + groupCoverage;

                  avoidDupl.push(data[i].briefingContent[l].parameters[0].toString());
                }
              }
            }
          }
        }

        // this sets the entire control height (detucted that one from above -> trackball)
        Q.progress_notFilled =
          "display: block;height:" +
          (Math.round((data[i].trackDistAndAlternate - data[i].alternateDist) * this.pixelDistanceFactor) -
            Math.round(data[i]._progress * this.pixelDistanceFactor)) +
          "px";
        Q.alternate_notFilled =
          "display: block;height:" + Math.round(data[i].alternateDist * this.pixelDistanceFactor) + "px";

        // elevation-profile graph (right of the magenta route line)
        const profile = data[i].elevationProfile;
        const baseProfile = data[i].elevationProfileBase;
        if (profile && profile.samples.length > 1 && profile.totalDistM > 0) {
          const graphW = 120;
          const graphH = Math.round(profile.totalDistM * this.pixelDistanceFactor);
          const yScale = graphH / profile.totalDistM;

          const maxHits = profile.samples.filter((s) => s.elevFt != null);
          const baseHits = (baseProfile?.samples ?? []).filter((s) => s.elevFt != null);

          // Both lines share one min..max scale so they read as comparable
          // values; max-pyramid output should always be ≥ base.
          const allElevs = [...maxHits.map((s) => s.elevFt as number), ...baseHits.map((s) => s.elevFt as number)];
          const minFt = allElevs.length ? Math.min(...allElevs) : 0;
          const maxFt = allElevs.length ? Math.max(...allElevs) : 1;
          const inset = 6;
          const span = Math.max(maxFt - minFt, 100);

          const buildPath = (hits: typeof maxHits) => {
            if (hits.length < 2) return "";
            const segments: string[] = [];
            for (let k = 0; k < hits.length; k++) {
              const s = hits[k];
              const y = s.distM * yScale;
              const x = inset + (((s.elevFt as number) - minFt) / span) * (graphW - inset);
              segments.push(`${k === 0 ? "M" : "L"} ${x.toFixed(1)} ${y.toFixed(1)}`);
            }
            return segments.join(" ");
          };

          Q.elevationGraphPath = buildPath(maxHits);
          Q.elevationGraphBasePath = buildPath(baseHits);
          Q.elevationGraphWidth = graphW;
          Q.elevationGraphHeight = graphH;
          Q.elevationGraphMaxFt = profile.maxFt;
          Q.elevationGraphStyle = `top:25px;left:18px;width:${graphW}px;height:${graphH}px`;

          // Ceiling overlay: tint the area between ceilingX and the max-line
          // wherever the max-line exceeds the user-configured ceiling. The
          // polygon outline traces the max-line forward and closes back along
          // ceilingX, with interpolated crossing points so slopes that rise
          // through ceiling get filled smoothly.
          const ceilingSettingRaw = await this.settings.getSetting("ceilingFt");
          // ion-input type="number" can persist as a string in some Ionic
          // setups; coerce so a saved "6500" doesn't silently fall back to
          // DEFAULT via the Number.isFinite check.
          const ceilingSettingFt =
            typeof ceilingSettingRaw === "string"
              ? Number(ceilingSettingRaw)
              : (ceilingSettingRaw as number | undefined);
          const CEILING_FT =
            Number.isFinite(ceilingSettingFt) && (ceilingSettingFt as number) > 0
              ? (ceilingSettingFt as number)
              : DEFAULT_CEILING_FT;
          // Clamp ceilingX into the graph's drawable X range so the closing
          // polygon edge cannot paint outside the chart's SVG viewport when
          // CEILING_FT lies above/below the route's elevation range.
          const rawCeilingX = 6 + ((CEILING_FT - minFt) / span) * (graphW - 6);
          const ceilingX = Math.max(6, Math.min(graphW, rawCeilingX));
          const buildCeilingPath = () => {
            const samples = profile.samples;
            const elevToX = (ft: number) => 6 + ((ft - minFt) / span) * (graphW - 6);
            const segs: string[] = [];
            const pts: Array<{ x: number; y: number }> = [];
            const flush = () => {
              if (pts.length < 2) {
                pts.length = 0;
                return;
              }
              const path: string[] = [];
              path.push(`M ${pts[0].x.toFixed(1)} ${pts[0].y.toFixed(1)}`);
              for (let k = 1; k < pts.length; k++) {
                path.push(`L ${pts[k].x.toFixed(1)} ${pts[k].y.toFixed(1)}`);
              }
              path.push("Z");
              segs.push(path.join(" "));
              pts.length = 0;
            };
            let prevX: number | null = null;
            let prevY: number | null = null;
            let prevAbove = false;
            for (const s of samples) {
              if (s?.elevFt == null) {
                if (prevAbove && prevY !== null) {
                  pts.push({ x: ceilingX, y: prevY });
                  flush();
                }
                prevX = null;
                prevY = null;
                prevAbove = false;
                continue;
              }
              const sx = elevToX(s.elevFt);
              const sy = s.distM * yScale;
              const above = sx > ceilingX;
              if (prevX === null) {
                if (above) {
                  pts.push({ x: ceilingX, y: sy });
                  pts.push({ x: sx, y: sy });
                }
              } else if (above !== prevAbove) {
                const t = (ceilingX - prevX) / (sx - prevX);
                const crossY = (prevY as number) + (sy - (prevY as number)) * t;
                pts.push({ x: ceilingX, y: crossY });
                if (above) {
                  pts.push({ x: sx, y: sy });
                } else {
                  flush();
                }
              } else if (above) {
                pts.push({ x: sx, y: sy });
              }
              prevX = sx;
              prevY = sy;
              prevAbove = above;
            }
            if (prevAbove && prevY !== null) {
              pts.push({ x: ceilingX, y: prevY });
              flush();
            }
            return segs.join(" ");
          };
          const ceilingPath = buildCeilingPath();
          Q.elevationGraphCeilingPath = ceilingPath || undefined;

          // Obstacles: place each span at (terrain elevation at midpoint) + 25 m
          // on the X axis, route-distance range on Y (enforced minimum height
          // so perpendicular cable crossings stay visible). The on-device
          // geometry rows carry no per-obstacle valHgt, so 25 m is an interim
          // constant — see docs/raw/2026-05-24-1208-flow-briefing-elevation-graph-obstacles.md
          // for the planned rework.
          const obstacleSpans = data[i].obstacleSpans;
          if (obstacleSpans && obstacleSpans.length > 0) {
            const M_TO_FT = 3.28084;
            const OBSTACLE_TOP_OFFSET_FT = 25 * M_TO_FT;
            const MIN_OBSTACLE_LINE_PX = 6;
            const ICON_SIZE = 20;

            const elevsM = await Promise.all(
              obstacleSpans.map((s) => pmtilesElevAt(s.midLon, s.midLat).catch(() => null))
            );

            const lines: ElevationGraphObstacleLine[] = [];
            const icons: ElevationGraphObstacleIcon[] = [];
            const endpoints: ElevationGraphObstacleEndpoint[] = [];
            const debugLines: { x1: number; x2: number; y: number }[] = [];
            // Per-cable pylon trails (id-keyed, geometry-order preserved by
            // emitPointSpans). Converted to <polyline> after the loop so the
            // pylons of one cable read as a connected line, not isolated dots.
            const pylonTrails = new Map<string, { x: number; y: number }[]>();
            for (let k = 0; k < obstacleSpans.length; k++) {
              const sp = obstacleSpans[k];
              const elevM = elevsM[k];
              if (elevM == null) continue;
              const topFt = elevM * M_TO_FT + OBSTACLE_TOP_OFFSET_FT;
              const x = inset + ((topFt - minFt) / span) * (graphW - inset);
              const y1 = sp.startDistM * yScale;
              const y2 = sp.endDistM * yScale;
              const yMid = (y1 + y2) / 2;
              const yExtent = Math.max(y2 - y1, MIN_OBSTACLE_LINE_PX);
              const yStart = yMid - yExtent / 2;
              const yEnd = yMid + yExtent / 2;
              const st = sp.style ?? {};
              if (sp.kind === "pylon") {
                // One dot per pylon coordinate that lands in-corridor.
                // All cables rendered red — on-device band styling is
                // intentionally ignored on this graph.
                endpoints.push({ cx: x, cy: yMid, r: 2.5, fill: "rgba(255,0,0,1)" });
                let trail = pylonTrails.get(sp.id);
                if (!trail) {
                  trail = [];
                  pylonTrails.set(sp.id, trail);
                }
                trail.push({ x, y: yMid });
              } else if (st.src) {
                // Anchor the rotated icon's right edge (post 90° clockwise =
                // the tower tip / obstacle peak) at the obstacle's X.
                icons.push({
                  x: x - ICON_SIZE,
                  y: yMid - ICON_SIZE / 2,
                  size: ICON_SIZE,
                  iconHref: routeObstacleIconHref(st.src),
                });
              }
            }
            const cables: ElevationGraphObstacleCable[] = [];
            for (const trail of pylonTrails.values()) {
              if (trail.length < 2) continue;
              // Sort by route-distance (y) so the polyline reads as a single
              // forward run along the route — OFMX pylon order isn't
              // guaranteed to be monotonic in route projection.
              const sorted = trail.slice().sort((a, b) => a.y - b.y);
              cables.push({
                points: sorted.map((p) => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" "),
                stroke: "rgba(255,0,0,0.5)",
                strokeWidth: 1,
              });
            }
            Q.elevationGraphObstacleLines = lines;
            Q.elevationGraphObstacleIcons = icons;
            Q.elevationGraphObstacleEndpoints = endpoints;
            Q.elevationGraphObstacleCables = cables;
            Q.elevationGraphObstaclePointDebug = debugLines;
          }

          // Right-side content blocks: marker maps each block's route-distance
          // (in metres) to SVG-y via yScale, so the marker points at the route
          // segment the block describes — independent of any layout offset
          // applied to position the visible box.
          const markers: ElevationGraphContentMarker[] = [];
          for (const b of Q.briefingContent) {
            if (b.trackDistMeters == null) continue;
            const cy = b.trackDistMeters * yScale;
            if (cy >= 0 && cy <= graphH) markers.push({ cy });
          }
          Q.elevationGraphContentMarkers = markers;
          Q.elevationGraphContentMarkersBaseline = markers.slice();
          Q.elevationGraphTotalDistM = profile.totalDistM;

          // Peak labels: greedy "tallest peak per neighborhood" pass on the
          // max-line. Sort local maxima by elevation desc, label the highest,
          // mask everything within ±PEAK_SUPPRESS_RADIUS_PX of its route-y as
          // taken, repeat. Stop once the next unprocessed peak falls below
          // 60% of the graph's usable width (= ~60% of the min..max span).
          if (maxHits.length > 0) {
            type Peak = { y: number; x: number; elevFt: number };
            const peaks: Peak[] = [];
            for (let k = 0; k < maxHits.length; k++) {
              const cur = maxHits[k].elevFt as number;
              const prev = k > 0 ? (maxHits[k - 1].elevFt as number) : -Infinity;
              const next = k < maxHits.length - 1 ? (maxHits[k + 1].elevFt as number) : -Infinity;
              // Plateau-leading edge counts; plateau interior does not. The
              // trailing edge can also slip through here — suppression below
              // collapses it into the leading peak's neighborhood anyway.
              if (cur >= prev && cur >= next && (cur > prev || cur > next)) {
                peaks.push({
                  y: maxHits[k].distM * yScale,
                  x: inset + ((cur - minFt) / span) * (graphW - inset),
                  elevFt: cur,
                });
              }
            }
            peaks.sort((a, b) => b.elevFt - a.elevFt);
            const PEAK_X_MIN = inset + 0.6 * (graphW - inset);
            const PEAK_SUPPRESS_RADIUS_PX = 300;
            const peakLabels: ElevationGraphPeakLabel[] = [];
            const taken: boolean[] = new Array(peaks.length).fill(false);
            for (let k = 0; k < peaks.length; k++) {
              if (taken[k]) continue;
              const p = peaks[k];
              if (p.x < PEAK_X_MIN) break;
              const elevRounded = Math.round(p.elevFt);
              // Width estimate for the "<N> ft" label rendered at the 12 px
              // font in the SCSS — enough to leave a small gap before the
              // leader line starts. ~7 px/char + " ft" + padding.
              const labelChars = String(elevRounded).length + 3;
              const lineStartX = 4 + labelChars * 7 + 4;
              peakLabels.push({
                x: p.x,
                y: p.y,
                elevFt: elevRounded,
                lineStartX,
              });
              for (let j = k + 1; j < peaks.length; j++) {
                if (!taken[j] && Math.abs(peaks[j].y - p.y) <= PEAK_SUPPRESS_RADIUS_PX) {
                  taken[j] = true;
                }
              }
            }
            Q.elevationGraphPeakLabels = peakLabels;
          }
        }

        // see whether we need to increase the bottom space margin
        let bottomMarginSpacer: number = 0;
        const webcamGroupEstHeight: number = 120; // pixel
        const showExtened: boolean =
          incBottomMargin_lastY * this.pixelDistanceFactor >
          data[i].trackDistAndAlternate * this.pixelDistanceFactor - webcamGroupEstHeight;

        if (showExtened) {
          // this means YES, please have an increased termination size of the panel
          bottomMarginSpacer =
            Math.round(data[i].trackDistAndAlternate * this.pixelDistanceFactor) +
            this.flowBriefingBottomMargin_px +
            180;
        } else {
          bottomMarginSpacer =
            Math.round(data[i].trackDistAndAlternate * this.pixelDistanceFactor) + this.flowBriefingBottomMargin_px;
        }

        // to avoid empty containers + the last changes
        // remove the last linebreak in desc (cosmetics only)
        npl.descr = npl.descr.substring(0, npl.descr.length - 5);
        if (npl.descr?.trim() || npl.images?.length || npl.documents?.length) Q.briefingContent.push(npl);
        Q.briefingContent = Q.briefingContent.filter(
          (group) => group.descr?.trim() || group.images?.length || group.documents?.length
        );
        Q.gapfiller = flowBriefingGaps(Q.briefingContent, this.pixelDistanceFactor, groupCoverage, offset, (meters) =>
          gapFillerRemark(meters, data[i].acft?.tacticalAirspeed)
        );

        // hack
        Q.buttonstyle = [];

        // dynamic expand panel when active, collapse when archived
        if (data[i].status == briefgFlowFlightStatusEnum.archive) {
          this.flightPanelState_1maximized_2minimized[data[i].flightId] = 2;

          // allow override by user
          if (this.flightPanelState_1maximized_2minimized_userOverride[data[i].flightId] == 1) {
            this.flightPanelState_1maximized_2minimized[data[i].flightId] = 1;
          }
        }

        if (data[i].status == briefgFlowFlightStatusEnum.planned) {
          this.flightPanelState_1maximized_2minimized[data[i].flightId] = 1;

          // allow override by user
          if (this.flightPanelState_1maximized_2minimized_userOverride[data[i].flightId] == 2) {
            this.flightPanelState_1maximized_2minimized[data[i].flightId] = 2;
          }
        }

        if (data[i].status == briefgFlowFlightStatusEnum.active) {
          this.flightPanelState_1maximized_2minimized[data[i].flightId] = 1;

          // allow override by user
          if (this.flightPanelState_1maximized_2minimized_userOverride[data[i].flightId] == 2) {
            this.flightPanelState_1maximized_2minimized[data[i].flightId] = 2;
          }
        }

        if (this.flightPanelState_1maximized_2minimized[data[i].flightId] == 2) {
          Q.controlStyle = "display: block;height:160px;";
          Q.buttonstyle[0] = "code-working-sharp";
        } else {
          Q.buttonstyle[0] = "code-download-sharp";
          Q.controlStyle = "display: block;" + "height:" + bottomMarginSpacer + "px;";
        }

        // if the flight is active, make a yellow style left border
        if (data[i].status == briefgFlowFlightStatusEnum.active) {
          Q.controlStyle += "border-left: 4px yellow solid;";
        }

        // if the warning, make a orange style left border
        if (data[i].status == briefgFlowFlightStatusEnum.alert) {
          Q.controlStyle += "border-left: 5px orange solid;";
        }

        localList.push(Q);
      }

      this.briefingFlowContent_forPageHtml = localList;
      return localList;
    } catch (Err) {
      console.log("could not load brfg flow section " + Err);
    }
  }

  async showLoadAndBalanceReport(flightId: string, opsMissionType: opsMissionTypeEnum) {
    try {
      const html: string = await this.focMain.getLoadAndBalanceHtmlReport(flightId, opsMissionType);
      this.navS.setParameters({ htmlString: html });
      this.navCtrl.navigateForward("/md-preview").catch((err) => console.error("navigateForward: ", err));
    } catch (err) {
      console.log("ERR: cant load load and balance report! " + err);
    }
  }

  async showFuelReport(flightId: string, opsMissionType: opsMissionTypeEnum) {
    try {
      const q = new fuelCalcReport();

      const htmlFuel: string = await q.getFuelReport(flightId, opsMissionType, classCom);

      this.navS.setParameters({ htmlString: htmlFuel });
      this.navCtrl.navigateForward("/md-preview").catch((err) => console.error("navigateForward: ", err));
    } catch (err) {
      console.log("ERR: cant load fuel report! " + err);
    }
  }

  async showNavReport(flightId: string) {
    try {
      const q = new navLogReport(classCom);
      const htmlNav: string = await q.getNavHtmlReport(flightId);

      this.navS.setParameters({ htmlString: htmlNav });
      this.navCtrl.navigateForward("/md-preview").catch((err) => console.error("navigateForward: ", err));
    } catch (err) {
      console.log("ERR: cant nav fuel report! " + err);
    }
  }

  async showMetReport(flightId: string) {
    try {
      const q = new metarReport();
      const htmlNav: string = await q.getMetReport(flightId, classCom, false);

      this.navS.setParameters({ htmlString: htmlNav });
      this.navCtrl.navigateForward("/md-preview").catch((err) => console.error("navigateForward: ", err));
    } catch (err) {
      console.log("ERR: cant nav fuel report! " + err);
    }
  }

  async showNotamReport(flightId: string) {
    try {
      const q = new notamReport();
      const htmlNav: string = await q.getNotamHtmlReport(flightId, classCom, false);

      this.navS.setParameters({ htmlString: htmlNav });
      this.navCtrl.navigateForward("/md-preview").catch((err) => console.error("navigateForward: ", err));
    } catch (err) {
      console.log("ERR: cant nav fuel report! " + err);
    }
  }

  async showPerfReport(flightId: string, opsMissionType: opsMissionTypeEnum) {
    try {
      const q = new performanceReport();
      const htmlNav: string = await q.getPerformanceHtmlReport(flightId, opsMissionType, classCom);

      this.navS.setParameters({ htmlString: htmlNav });
      this.navCtrl.navigateForward("/md-preview").catch((err) => console.error("navigateForward: ", err));
    } catch (err) {
      console.log("ERR: cant nav perf report! " + err);
    }
  }

  public async toggleBriefingPanel(flightId: string): Promise<briefgFlowComponentStruct[]> {
    if (this.flightPanelState_1maximized_2minimized[flightId] == undefined)
      this.flightPanelState_1maximized_2minimized[flightId] = 2;

    if (this.flightPanelState_1maximized_2minimized[flightId] == 1) {
      this.flightPanelState_1maximized_2minimized_userOverride[flightId] = 2;

      return this.loadFlowBrfg(true);
    }
    if (this.flightPanelState_1maximized_2minimized[flightId] == 2) {
      this.flightPanelState_1maximized_2minimized_userOverride[flightId] = 1;

      return this.loadFlowBrfg(true);
    }
  }

  public mapMsg = new Subject<string>();

  displayMapMessage(msg: string) {
    this.mapMsg.next(msg);
  }

  // change duy id of a flight
  // needed if switched to adhoc
  async updateDutyIdOfFlight(oldDutyid: string, newDutyId: string) {
    // Reassign the duty-id FK on this duty's live (pre-departure) flights.
    // Multi-row write → catalog `flightlistReassignFlightCrewId` (web routes it
    // through the server's sync expansion; mobile runs the UPDATE locally).
    await classCom.namedCommand("flightlistReassignFlightCrewId", {
      oldDutyId: oldDutyid,
      newDutyId,
    });
  }

  private getOpsMissionTypesOfCurrentDuty(): { str: number; en: string }[] {
    const parameters = this.currentDutyOfpLimits?.parameters ?? "";

    const match = parameters.match(/^(\w+):\[(.*?)\]$/);

    if (!match) {
      console.error("Duty parameters format is invalid:", parameters);
      return [];
    }

    const enabledMissionTypes = new Set(
      match[2]
        .split(",")
        .map((v) => v.trim())
        .filter((v) => v.length > 0)
    );

    return Object.keys(opsMissionTypeEnum)
      .filter((key) => !Number.isNaN(Number(key)))
      .map((key) => {
        const str = Number(key);
        const en = opsMissionTypeEnum[str];

        return { str, en };
      })
      .filter(({ en }) => enabledMissionTypes.has(en));
  }

  // Stop the ahead-flight chain at `failedIndex` and invalidate every flight
  // AFTER it. Those flights were computed from the fuel figure this flight was
  // supposed to replace, and nothing else marks them stale — see the call sites.
  private async stopChainAndInvalidate(
    chainFlights: flightlistStruct[],
    failedIndex: number,
    reason: string,
    // Flights the CALLER knows the state of, because it acted on them before
    // calling: `alreadyStale` = retirement was attempted and failed,
    // `alreadyCleared` = retirement succeeded. Without the second one the
    // "N invalidated" count under-reported the flight the loop had just swept.
    alreadyStale: string[] = [],
    alreadyCleared: string[] = []
  ): Promise<void> {
    const invalidated = chainFlights.slice(failedIndex + 1);

    // BEST-EFFORT, per flight. An unguarded loop let the first rejected write
    // strand every flight after it, and skipped the alert too — so the crew was
    // told the recycle failed but never which flights were left stale. Each
    // flight is independent, so a failure on one is no reason to skip the rest.
    const stillLive: string[] = [...alreadyStale];
    const cleared: string[] = [...alreadyCleared];

    for (const flight of invalidated) {
      if (await this.tryInvalidate(flight.flightId)) {
        cleared.push(flight.flightId);
      } else {
        stillLive.push(flight.flightId);
      }
    }

    // WARNING FIRST. The body is unbounded — one entry per failed mission, each
    // carrying a `lastError` — so on a multi-mission failure the tail of the
    // message can be pushed off an iPad screen. The clause the crew MUST read
    // is the one naming flights that still display stale calculations, so it
    // leads; the reason and the reassuring clause follow.
    let message = "";

    if (stillLive.length > 0) {
      message +=
        "WARNING — these flights could NOT be invalidated and may still show stale calculations: " +
        stillLive.join(", ") +
        ". ";
    }

    // Alert unconditionally: the failure that stopped the chain may be the LAST
    // flight, where there is nothing to invalidate but the operator still has
    // to be told the recycle stopped. Only the list clauses are conditional.
    message += reason;

    // `cleared`, NOT the whole `invalidated` slice — on a persistent transport
    // fault every flight lands in `stillLive`, and reporting the same ids as
    // both invalidated and not-invalidated made the reassuring sentence the
    // false one.
    if (cleared.length > 0) {
      message +=
        ". " + cleared.length + " ahead flight(s) were invalidated and must be recalculated: " + cleared.join(", ");
    }

    await this.alert.showAlert("ahead flight calculations stopped", message);
  }

  // One retry, and ONLY for the case the server marks retryable.
  //
  // The earlier version retried every rejection immediately, which was wrong
  // three ways. It re-attempted faults the server explicitly marks terminal —
  // the projection-refusal 500 (`retryable: false, terminal: true`), a terminal
  // 409, and a 401 that has already cleared the session and navigated to
  // `/login`. It used no delay, while this repo's own policy for the analogous
  // case is 250 ms PLUS jitter (`selectProcess`, and see the note in
  // `database.service.browser.ts`: a fixed delay re-delivers a refused wave in
  // lockstep). And on NATIVE these are local SQLite writes that never see
  // `/command` at all, so the 503 rationale did not apply on the platform the
  // automatic trigger actually runs on — there `isTransientProcessDbError` is
  // simply false and this costs one attempt, as it should.
  //
  // A persistent fault is re-attempted by the next recycle trigger — the fuel
  // and POB numpads, the duty sign, the flight-record edit, and landing
  // detection in `flight-timer.service.ts` — each of which sweeps this same set
  // again. That cadence is the real retry mechanism; a durable queue would be
  // new machinery covering nothing it does not already cover.
  private async tryInvalidate(flightId: string): Promise<boolean> {
    for (let attempt = 1; attempt <= 2; attempt++) {
      try {
        await this.markFlightCalculationsObsolete(flightId);

        return true;
      } catch (err) {
        console.error("could not invalidate flight " + flightId + " (attempt " + attempt + "): ", err);

        if (attempt === 2 || !isTransientProcessDbError(err)) return false;

        await new Promise((resolve) => setTimeout(resolve, 250 + Math.random() * 250));
      }
    }

    return false;
  }

  private async markFlightCalculationsObsolete(flightId: string): Promise<void> {
    // Invalidate this flight's W&B / perf / fuel calculations. Multi-row writes
    // → catalog obsolete-by-flight entries (web routes them through the server's
    // sync expansion; mobile runs the UPDATEs locally).
    await Promise.all([
      classCom.namedCommand("loadingObsoleteByFlight", { flightId }),
      classCom.namedCommand("perfObsoleteByFlight", { flightId }),
      classCom.namedCommand("fuelObsoleteByFlight", { flightId }),
    ]);
  }
}

export class briefgFlowComponentStruct {
  data: briefgFlowFlightStruct;
  controlStyle: string;
  progress_inner: string;
  progress_notFilled: string;
  alternate_notFilled: string;
  progress_label: briefgFlowProgLabelStruct[];
  briefingContent: briefgFlowProgLabelStruct[];
  gapfiller: gapFillerStruct[];
  buttonstyle: string[];
  droneflights: briefgFlowProgLabelStruct[];
  elevationGraphStyle?: string;
  elevationGraphPath?: string;
  elevationGraphBasePath?: string;
  elevationGraphWidth?: number;
  elevationGraphHeight?: number;
  elevationGraphMaxFt?: number;
  elevationGraphObstacleLines?: ElevationGraphObstacleLine[];
  elevationGraphObstacleIcons?: ElevationGraphObstacleIcon[];
  elevationGraphObstacleEndpoints?: ElevationGraphObstacleEndpoint[];
  elevationGraphObstacleCables?: ElevationGraphObstacleCable[];
  elevationGraphObstaclePointDebug?: { x1: number; x2: number; y: number }[];
  elevationGraphCeilingPath?: string;
  elevationGraphContentMarkers?: ElevationGraphContentMarker[];
  // Immutable briefingContent-only markers snapshot. The drone path in
  // flow-briefing-auto-page rebuilds elevationGraphContentMarkers as
  // baseline + current drones on every traffic refresh — pushing into the
  // live array would accumulate drone duplicates across refreshes.
  elevationGraphContentMarkersBaseline?: ElevationGraphContentMarker[];
  elevationGraphTotalDistM?: number;
  elevationGraphPeakLabels?: ElevationGraphPeakLabel[];
}

export interface ElevationGraphContentMarker {
  cy: number;
}

export interface ElevationGraphPeakLabel {
  x: number;
  y: number;
  elevFt: number;
  lineStartX: number;
}

export interface ElevationGraphObstacleEndpoint {
  cx: number;
  cy: number;
  r: number;
  fill: string;
}

export interface ElevationGraphObstacleLine {
  x: number;
  y1: number;
  y2: number;
  stroke: string;
  strokeWidth: number;
  dash?: string;
}

export interface ElevationGraphObstacleCable {
  points: string;
  stroke: string;
  strokeWidth: number;
}

export interface ElevationGraphObstacleIcon {
  x: number;
  y: number;
  size: number;
  iconHref: string;
}

export class briefgFlowProgLabelStruct {
  desigStyle: string;
  desig: string;
  descr: string;
  age_min: string;
  ageCss: string;
  images: any[];
  documents?: { html: string; title: string; address: string; toolId: number }[];
  parameter: any[];
  trackDistMeters?: number;
}

export class gapFillerStruct {
  remark: string;
  style: string;
}

export enum dutyTypeEnum {
  unknown = 0,
  managed_avail = 1,
  adhoc_only = 2,
  last_minute_change = 3,
}

/**
 * The label of a gap between two briefing-card groups: its distance, and its
 * flight time at the aircraft's tactical airspeed (m/s) when that is known.
 */
export function gapFillerRemark(distM: number, airspeedMps: number | undefined): string {
  const nm = Math.round(distM * 0.000539957) + " nm";
  return airspeedMps > 0 ? nm + " / " + Math.round(distM / airspeedMps / 60) + " min" : nm;
}
